import { AuthenticationService } from "./../authentication.service";
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { DataService } from "../data.service";
import { DecimalPipe } from "@angular/common";
import { parse, format, AsYouType } from "libphonenumber-js";
import { EventsService } from "angular4-events";
// // import {MarkerClusterer} from '@google/markerclusterer';
// import * as jsPDF from 'jspdf';
import { detectChanges } from "@angular/core/src/render3";
import { IMyDpOptions, IMyDateModel, IMyDate } from "mydatepicker";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Constants } from "../constants";
import * as moment from "moment";
import { couldStartTrivia } from "typescript";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs/Subscription";
import { ChatModalComponent } from "../modals/chat-modal/chat-modal.component";

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var MarkerClusterer: any;
declare var toastr: any;
declare var jQuery: any;
@Component({
  selector: "app-order-listing",
  templateUrl: "./order-listing.component.html",
  styleUrls: ["./order-listing.component.css"],
})
export class OrderListingComponent implements OnInit {
  @ViewChild("mapCanvas") mapElement: ElementRef;
  @ViewChild("mapCanvas2") mapElement2: ElementRef;
  @ViewChild("mapCanvasTrack") mapElement3: ElementRef;
  priceIconForDouble = Constants.iconForDoublePrice;
  priceIconForSingle = Constants.iconForSinglePrice;
  nao = new Nanobar();
  map: any;
  // page=0;
  pageLoad = 0;
  last_page: any;
  paginatedData: any;
  limit: any;
  page2 = 0;
  last_page2: any;
  paginatedDataOrder: any;
  limit2: any;
  limitOrder: any;
  last_pageOrder: any;
  pageOrder = 0;
  qrCode: any;
  newWin: any;
  divToPrint: any;
  newWin2: any;
  divToPrint2: any;
  map2: any;
  mapTrack: any;
  marker = new Array();
  infowindow = new Array();
  infowindowTrack = new Array();
  marker2 = new Array();
  markerDrop = new Array();
  markerDrivers = new Array();
  markerTrack = new Array();
  batchArray = new Array();
  latitude = 31.4666305;
  longitude = 74.4125222;
  latitude2 = 31.4666305;
  longitude2 = 74.4125222;
  directionsService: any;
  directionsDisplay: any;
  options: any;
  clearTimeout: any;
  clearTimeout2: any;
  clearTimeoutBatch: any;
  searchTimeOut: any;
  orderData: any;
  packedDataArray = new Array();
  trackData: any;
  trackDataDispensary: any;
  trackDataDriver: any;
  trackDataOrder: any;
  query: any;
  success: any;
  error: any;
  orderName = "Order -Type";
  pushReceive: any;
  detailData: any;
  detailTotalCharges = 0;
  lengthCount: any;
  detailDataLength: any;
  detailDataSuccess: any;
  driverData: any;
  searchStringCustomer: any;
  driverDataLength: any;
  DisplayDataArray = new Array();
  driverId: any;
  bookorderdata: any;
  bookOrderSuccess: any;
  selectedDriverName: any;
  hideDriverFindField = false;
  batchBtn = false;
  batchDetailId: any;
  bookOrderMessage: any;
  createBatchData: any;
  getBatchData: any;
  batchId: any;
  removeBatchorderBtn = true;
  loader = false;
  imgProcess = true;
  packaginInstrutionObj: any;
  customRemovableArray = new Array();
  intervalSet: any;
  trackDataDriverIdForRoute: any;
  driverPinLat: any;
  driverPinLong: any;
  driverPin: any;
  transitData = new Array();
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  userDropDocs: any;
  orderDataDisplay: any;
  deliverStartDate: any;
  deliverEndDate: any;
  pickupAddress: any;
  productData: any;
  cancelStatusSuccess: any;
  returnStatusSuccess: any;
  onDetailDriverData: any;
  thirdPartyData: any;
  defaultViewToShow = false;
  type = "data";
  // driver detail vars
  btnDisableDriver = false;
  first_nameDriver: any;
  last_nameDriver: any;
  phoneDriver: any;
  emailDriver: any;
  dobDriver: any;
  address_line1Driver: any;
  address_line2Driver: any;
  cityDriver: any;
  stateDriver: any;
  zipDriver: any;
  areaDriver: any;
  noteDriver: any;
  driving_license_frontDriver: any;
  driving_license_backDriver: any;
  registration_bookDriver: any;
  successDriver: any;
  latitudeDriver: any;
  longitudeDriver: any;
  findDriverDataDriver: any;
  driverMatchDriver = true;
  dispenseriesDriver: any;
  userImageDriver: any;
  // Customer detail vars
  first_nameCustomer: any;
  last_nameCustomer: any;
  numberCustomer: any;
  customerDetailDob: any;
  emailCustomer: any;
  is_tax_exemptCustomer = false;
  accept_marketingCustomer = false;
  address_line1Customer: any;
  address_line2Customer: any;
  cityCustomer: any;
  stateCustomer: any;
  zipCustomer: any;
  areaCustomer: any;
  apartCustomer: any;
  noteCustomer: any;
  findCustomerData: any;
  customerMatchCustomer = false;
  latitudeCustomer: any;
  longitudeCustomer: any;
  userImageCustomer: any;
  orderDetailToReopenOpId: any;
  Paginationdisable: any;
  // Update Route Params
  numDeltas = 10;
  delay = 100; // milliseconds
  r: any;
  deltaLat: any;
  deltaLng: any;
  driverMarker: any;
  previousDriverLatLng: any;
  startDriverLatLng: any;
  numberOfDriverLocationChecks: any;
  currentDriverLocation: any;
  trackOrderId: any;
  rollOverStatusSuccess: any;
  printPopOpen = false;
  orderStatus: any;
  searchOrderString: any;
  filterValue = "All";
  availableDriverData;
  availableDrivers = new Array();
  runningDrivers = new Array();
  showAvailability = false;
  mcDetail: any;
  mapEle2: any;
  delivery_man_type: any;
  delivery_sub_btn = true;
  delivery_order_id = true;
  DeliveryManTypeData: any;
  thirdPartyName = "";
  thirdPartyDate: any;
  thirdPartyUrl = "";
  thirdPartyId = "";
  thirdPartybtn = true;
  thirdPartyOrderId: any;
  thirdPartyOrderStatus: any;
  thirdPartySuccessData: any;
  rebookData: any;
  reprocessData: any;
  orderDeliverPerson = "";
  orderDeliverDate: any;
  orderDeliverTime = "";
  orderDeliverHandler = "";
  orderDeliverBtn = true;
  private today = new Date();
  selDate: any;
  limitOrders = 20;
  btnShowAfterDataLoad = false;
  currentYear = this.today.getUTCFullYear();
  currentDate = this.today.getUTCDate() - 1;
  currentMonth = this.today.getUTCMonth() + 1;
  date = new Date();
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showTodayBtn: true,
    todayBtnTxt: "Today",
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    disableUntil: {
      year: this.currentYear,
      month: this.currentMonth,
      day: this.currentDate,
    },
    // disableSince: {year: this.today.getFullYear(), month: this.currentMonth, day: this.currentDate + 2},
  };
  myDatePickerOptions2: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showTodayBtn: true,
    todayBtnTxt: "Today",
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    // disableUntil: {year: this.currentYear, month: this.currentMonth, day: this.currentDate},
    disableSince: {
      year: this.today.getFullYear(),
      month: this.currentMonth,
      day: this.currentDate + 2,
    },
  };
  markIntransitData: any;
  markDeliveredData: any;
  deliverdOrderId: any;
  markAsDeliveredText: any;
  key: any;
  tokenProfielData: any;
  orderDataUncubscribe: any;
  orderDataUncubscribeValue = false;
  serviceCityIdForOrders: any;
  serviceCityForOrders: any = "Services - All";
  searchBusinessDetailforOrder: Object;
  showSearchResults: boolean = false;
  serviceCity: string;
  returnOrderItems: any;
  returnOrderItemsLength: any;
  orderCreated: void;
  orderBooked: any;
  delivered: any;
  tableNo: any;
  order_id: any;
  order_status: any;
  index: any;
  get_invoice_id: any;

  get UserRole(): any {
    return localStorage.getItem("userRole");
  }
  get meter(): any {
    return localStorage.getItem("meter");
  }
  batchSearch = "";
  driverContactInfo: any;
  stockCountOrder: any;
  outletName = "Outlet - All";

  outletData: any;
  outletData1: any;
  outletId = -1;

  selectedOutletData: any;
  SelectedcitiesList: any;
  SelectedCitiesTimes: any;
  outletDayindex = -1;
  outletDay = "Day - All";
  outletDayTime = "Day - All";
  time: any;
  openTime: any;
  closeTime: any;
  dayOfGivenTime: any;
  dayIndex: any;
  slotsTimingsToShow = [];
  slotsTimingsToShowBackup = [];
  timeSlotDetail_delivery_show = new Array();
  selectionDayOpenTime = "-1";
  selectionDayCloseTime = "-1";
  selectionDayOpenTime2: any;
  selectionDayCloseTime2: any;
  outletDaySelect = false;
  id: any;
  name: any;
  orderId: any;
  ordercancelid: any;

  packagingProduct: any;
  prodorderdisc: any;
  prodorderdelchar: any;
  prodordercharges: any;
  prodordersubtotal: any;
  prodordertotal: any;
  firstName: any;
  lastName: any;
  totalPacakgeQuantity: any;
  totalPacakgeSaving: any;
  dispensary_name: any;
  dispensary_image: any;
  OrderList: any;
  paginationCheck: any;
  lastPage: any;
  cityName: any;
  isDisable = false;
  isDisableOrderBtn = false;
  searchBusiness: any;
  searchTabBusiness: any;
  dineIn: boolean = false;
  pickUp: boolean = false;
  applicable: boolean = false;

  // For Business Invoice Detail Modal
  invoice_id: string = "";
  invoice_amount: string = "";
  invoiceImagePath: string;
  invoiceImage: File;

  // For Business Invoice Detail Modal
  transaction_id: string = "";
  credited_to: string = "";
  transactionImagePath: string;
  transactionImage: File;

  checkPopupOpenFlag: boolean = true;
  constructor(
    private dataService: DataService,
    private authService: AuthenticationService,
    private chRef: ChangeDetectorRef,
    private pubsub: EventsService,
    private activatedRoute: ActivatedRoute,
    private events: EventsService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    public modalService: NgbModal
  ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.key = params["t"];
      console.log("param key value chk token", this.key);
    });
    if (this.key !== undefined) {
      this.profileDataFunction(this.key);
      // this.getBusinessAccountsFunction(this.key);
    }
    setTimeout(() => {
      if (window.localStorage.getItem("isauthenticated") !== "true") {
        window.location.href = "/";
      }
      // this.orderslist(0);
      this.getBatcheslist();
    }, 50);
    this.options = {
      onUpdate: (event: any) => {
        console.log("in drag function");
        this.editBatchFunction();
        // this.batchDetailFunction(this.batchDetailId);
      },
    };
    setTimeout(() => {
      this.selDate = this.today;
    }, 1500);
  }

  showCreateOrder() {
    toastr.error(
      "To create order please make sure your business profile is complete and payment method is added."
    );
  }

  businessDetailforOrder: any;
  businessForOrders = "Business";
  businessIdForOrders = "-1";

  getDispensaryListingforOrder() {
    this.dataService
      .getdispensaryListing(localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.businessDetailforOrder = data;
          this.searchBusinessDetailforOrder = data;
          // console.log('businessDetailforOrder', businessDetailforOrder);
          this.businessForOrders = "Business";
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  createOrder(id, name) {
    this.businessIdForOrders = id;
    this.businessForOrders = name;
  }

  createOrderService(id, cityName) {
    this.serviceCityIdForOrders = id;
    if (cityName == "Services - All") {
      this.serviceCityForOrders = "Services - All";
      this.serviceCity = "";
    } else {
      this.serviceCityForOrders = cityName;
      this.serviceCity = cityName;
    }
    this.dataService
      .getdispensaryListingById(
        localStorage.getItem("token"),
        this.serviceCity,
        ""
      )
      .subscribe(
        (data) => {
          this.businessDetailforOrder = data;
          this.searchBusinessDetailforOrder = data;
          this.businessForOrders = "Business";
        },
        (error) => {
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  buttonClick() {
    this.businessIdForOrders;
    if (this.businessIdForOrders !== "-1") {
      window.localStorage.setItem("businessId", this.businessIdForOrders);
      window.localStorage.setItem("routetype", "create");

      this.router.navigate(["create-order"]);
    } else {
      toastr.error("Select the business to create the order");
    }
  }

  recreateOrder(id) {
    window.localStorage.setItem("reprocessId", id);
    window.localStorage.setItem("routetype", "process");

    this.router.navigate(["create-order"]);
  }

  editOrder(id, order) {
    window.localStorage.setItem("despensId", id);
    this.router.navigate(["order-edit", order]);
  }

  profileDataFunction(token) {
    // this.nao.go(30);
    this.dataService.profileData(token).subscribe(
      (data) => {
        // this.nao.go(100);
        this.tokenProfielData = data;
        window.localStorage.setItem("isauthenticated", "true");
        window.localStorage.setItem("token", token);
        window.localStorage.setItem(
          "businessCardExistValue",
          this.tokenProfielData.add_card
        );
        window.localStorage.setItem(
          "displayName",
          this.tokenProfielData.first_name
        );
        window.localStorage.setItem(
          "dispensaryImage",
          this.tokenProfielData.image
        );
        window.localStorage.setItem(
          "meter",
          this.tokenProfielData.complete_meter
        );
        window.localStorage.setItem("alias", this.tokenProfielData.alias);
        window.localStorage.setItem("userRole", this.tokenProfielData.role);
        this.events.publish(
          "dispensaryImageUpdate",
          this.tokenProfielData.image
        );
        this.events.publish(
          "meterUpdate",
          this.tokenProfielData.complete_meter
        );
        this.events.publish(
          "businessCardExist",
          this.tokenProfielData.add_card
        );
      },
      (error) => {
        // this.nao.go(100);
        console.log("error", error);
        toastr.error("Some thing went wrong");
      }
    );
  }

  dataOrdersListing: any;
  city_id: any;
  order_type: any;
  getOrderListing() {
    this.dataService
      .getordersList(
        window.localStorage.getItem("token"),
        status,
        this.limitOrders,
        this.city_id,
        this.dispensary_id,
        this.outletId,
        this.outletDayindex,
        this.selectionDayOpenTime,
        this.selectionDayCloseTime,
        this.pageOrder,
        this.orderId
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);

          this.dataOrdersListing = data;
          this.lastPage = this.dataOrdersListing.last_page;
          this.dataOrdersListing = this.dataOrdersListing.items;
          this.pageOrder++;
          console.log("hello");
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  outletDatas: any;
  dispensary_id: any;

  completeOutletData: any;

  outlets() {
    this.dataService
      .getoutlets(localStorage.getItem("token"), this.dispensary_id)
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.completeOutletData = data;
          this.outletDatas = data;
          this.outletDatas = this.outletDatas.items;
          this.outletName = "Outlet - All";

          console.log("call in first function", this.outletDatas);
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  // filterOutletId(id, name, outlet){
  //   this.outletId = id;
  //
  // }

  servicesDatas: any;
  serviceName = "Services - All";

  city: any;
  getServices() {
    this.dataService.getservices(localStorage.getItem("token")).subscribe(
      (data) => {
        this.servicesDatas = data;
        this.servicesDatas = this.servicesDatas.city_list;
        this.orderslist(0);
      },
      (error) => {
        // this.nao.go(100);
        console.log("error", error);
        toastr.error("Some thing went wrong");
      }
    );
  }

  servicedetail: any;

  filterServiceId(city) {
    this.pageLoad = 0;
    console.log("cityfilter", city);

    this.serviceName = city;
    this.city_id = city;

    if (this.serviceName == "All") {
      this.serviceName = "Services - All";
    }
    if (this.serviceName != "Services - All") {
      this.city_id = city;
    } else if (this.serviceName == "Services - All") {
      this.city_id = "-1";
    }

    this.dataService
      .getdispensaryListingById(localStorage.getItem("token"), this.city_id, "")
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.servicedetail = data;
          console.log("Cities", this.servicedetail);
          // this.page++;
          // this.servicedetail = this.servicesDatas.city_list;

          // this.businessName = 'Business - ' + city
          this.dispensaryDetails = data;
          this.filterBusinessId(-1, name, "");
          this.orderslist(this.status);
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  dispensaryDetails: any;
  businessName = "Business - All";
  dispensaryId: any;

  getDispensaryListing() {
    // console.log('e');
    this.dataService
      .getdispensaryListing(localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.dispensaryDetails = data;
          this.businessName = "Business - All";
          this.orderslist(this.status);
          this.servicedetail = data;
          console.log(this.servicedetail);
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  filterBusinessId(id, name, detail) {
    this.dispensary_id = id;

    if (this.dispensary_id == -1) {
      this.businessName = "All Businesses";
    }

    if (this.dispensary_id != -1) {
      this.businessName = name;
    }

    console.log("dispansaryid", id);
    this.outlets();
    this.outletId = -1;
    this.orderslist(this.status);

    // this.dataService.getoutletsListOfBusiness(localStorage.getItem('token'), this.dispensaryId).subscribe(
    //   (data) => {
    //     // this.nao.go(100);
    //     this.servicedetail = data;
    //     // this.businessName = this.servicedetail.dispensary_name;
    //
    //
    //   },
    //   (error) => {
    //     // this.nao.go(100);
    //     console.log('error', error);
    //     toastr.error('Some thing went wrong');
    //   } ̰ ̰
    // );
  }
  // Get order service //

  OrderData: any;

  getOrderServices() {
    {
      this.dataService
        .getordersList(
          window.localStorage.getItem("token"),
          status,
          this.limitOrders,
          this.city_id,
          this.dispensary_id,
          this.outletId,
          this.outletDayindex,
          this.selectionDayOpenTime,
          this.selectionDayCloseTime,
          this.pageOrder,
          this.orderId
        )
        .subscribe(
          (data) => {
            // this.nao.go(100);
            //  if(this.OrderData[this.order_Type] == this.orderid)
            //  {
            this.OrderData = data;
            console.log("data", this.OrderData);
            this.orderslist(this.status);
            this.servicedetail = data;
            console.log("hello");
          },
          (error) => {
            // this.nao.go(100);
            console.log("error", error);
            toastr.error("Some thing went wrong");
          }
        );
    }
  }
  //Get dispansary listing //

  //  Filter order Search //
  filterOrderId(order_type, name, detail) {
    this.orderId = order_type;
    if (this.orderId == -1) {
      this.orderName = "All order";
    }
    if (this.orderId == 1) {
      this.orderName = "Delivery";
    }
    if (this.orderId == 2) {
      this.orderName = "Dine In";
    }
    if (this.orderId == 3) {
      this.orderName = "Pick-up";
    }

    console.log("orderid", order_type);
    this.getOrderServices();
    // this.outlets();
    this.outletId = -1;
    //this.orderslist(this.status);
  }

  status: any;
  orderslist(status) {
    this.status = status;
    this.searchTabBusiness = "";
    this.batchBtn = false;
    this.defaultViewToShow = false;
    this.btnShowAfterDataLoad = false;
    this.pageOrder = 0;
    this.nao.go(30);
    this.orderStatus = status;
    this.searchOrderString = "";
    this.filterValue = "ALL";
    this.packedDataArray = [];
    this.orderData = [];

    this.transitData = [];
    if (this.orderDataUncubscribeValue === true) {
      this.orderDataUncubscribe.unsubscribe();
    }
    this.orderDataUncubscribeValue = true;

    this.orderDataUncubscribe = this.dataService
      .getordersList(
        window.localStorage.getItem("token"),
        this.status,
        this.limitOrders,
        this.city_id,
        this.dispensary_id,
        this.outletId,
        this.outletDayindex,
        this.selectionDayOpenTime,
        this.selectionDayCloseTime,
        this.pageOrder,
        this.orderId
      )
      .subscribe(
        (data) => {
          this.nao.go(100);

          console.log("getorderlistapi");
          this.orderData = [];

          // this.outletId
          this.type = "data";
          this.orderData = data;
          console.log("status data", this.orderData);
          this.limitOrder = 2;
          this.stockCountOrder = data;
          this.stockCountOrder = this.stockCountOrder.stock_count;
          this.last_pageOrder = this.orderData.last_page;
          this.orderData = this.orderData.items;
          this.btnShowAfterDataLoad = true;
          if (this.stockCountOrder === 0) {
            this.defaultViewToShow = true;
          } else {
            this.defaultViewToShow = false;
          }

          for (var i = 0; i < this.orderData.length; i++) {
            if (
              this.orderData[i].open_time !== "" &&
              this.orderData[i].close_time !== ""
            ) {
              var cDate = new Date().getDate();
              var cYear = new Date().getFullYear();
              var cMonth = new Date().getUTCMonth() + 1;
              var openTime = this.orderData[i].open_time;
              var tOpen =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                openTime +
                " " +
                "UTC";
              var dateObjOpen = new Date(tOpen);
              this.orderData[i].open_time = dateObjOpen;

              var closeTime = this.orderData[i].close_time;
              var tClose =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                closeTime +
                " " +
                "UTC";
              var dateObjClose = new Date(tClose);
              this.orderData[i].close_time = dateObjClose;
            }
            if (this.orderData[i].status_updated_time !== "") {
              var dateObjOpen = moment
                .utc(this.orderData[i].status_updated_time)
                .toDate();
              this.orderData[i].status_updated_time = dateObjOpen;
            }
          }

          setTimeout(() => {
            this.chRef.detectChanges();
          }, 100);
          // for (var i = 0; i <= this.orderData.length - 1; i++) {
          //   if (this.orderData[i].order_status === 2) {
          //     this.packedDataArray.push(this.orderData[i]);
          //   }
          //   if (this.orderData[i].order_status === 4 || this.orderData[i].order_status === 9 || this.orderData[i].order_status === 10) {
          //     this.transitData.push(this.orderData[i]);
          //   }
          //   }
          //   console.log('this.packedDataArray', this.packedDataArray);
          //   console.log('this.transitData', this.transitData);
          // setTimeout(() => {
          if (this.status === 2) {
            // this.clearMarker();
          }
          // }, 2000);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  filterValUpdate(val, displayFilterString) {
    console.log("val", val);
    this.searchTabBusiness = "";
    if (val === this.orderStatus) {
      return;
    } else {
      this.orderStatus = val;
      this.filterValue = displayFilterString;
      this.searchAllOrders();
    }
  }

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService
        .getdispensaryListingById(
          localStorage.getItem("token"),
          this.serviceCity,
          this.searchBusiness
        )
        .subscribe(
          (data) => {
            this.showSearchResults = true;
            this.searchBusinessDetailforOrder = data;
          },
          (error) => {
            console.log("error", error);
            toastr.error("Some thing went wrong");
          }
        );
    });
  }

  searchAllOrders() {
    clearTimeout(this.searchTimeOut);
    this.pageLoad = 0;
    this.type = "search";
    this.searchTimeOut = setTimeout(() => {
      this.nao.go(30);
      // this.loader = false;
      console.log("login data 1");
      // var cityId = '-1';
      //     if (this.outletName == 'All'){
      //       this.outletName = 'outlets - All';
      //       console.log('outlets all first check', this.outletName);
      //     }
      //     if (this.outletName != 'outlets - All')
      //     {
      //       cityId = this.outletName;
      //       console.log('outlets city', this.outletName);
      //     }
      //     else if (this.outletName == 'outlets - All')
      //  {
      //   cityId = '-1';
      //   console.log('outlets all cities', this.outletName);
      //  }

      this.dataService
        .searchOrdersList(
          window.localStorage.getItem("token"),
          this.searchOrderString,
          this.orderStatus,
          this.limitOrders,
          this.city_id,
          this.dispensary_id,
          this.outletId,
          this.outletDayindex,
          this.selectionDayOpenTime,
          this.selectionDayCloseTime,
          this.orderId
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            this.orderData = data;
            this.limitOrder = 2;
            this.last_pageOrder = this.orderData.last_page;
            this.orderData = this.orderData.items;
            this.pageLoad++;
            if (this.orderStatus === 2) {
              // this.clearMarker();
            }

            for (var i = 0; i < this.orderData.length; i++) {
              if (
                this.orderData[i].open_time !== "" &&
                this.orderData[i].close_time !== ""
              ) {
                var cDate = new Date().getDate();
                var cYear = new Date().getFullYear();
                var cMonth = new Date().getUTCMonth() + 1;
                var openTime = this.orderData[i].open_time;
                var tOpen =
                  cYear +
                  "/" +
                  cMonth +
                  "/" +
                  cDate +
                  " " +
                  openTime +
                  " " +
                  "UTC";
                var dateObjOpen = new Date(tOpen);
                this.orderData[i].open_time = dateObjOpen;

                var closeTime = this.orderData[i].close_time;
                var tClose =
                  cYear +
                  "/" +
                  cMonth +
                  "/" +
                  cDate +
                  " " +
                  closeTime +
                  " " +
                  "UTC";
                var dateObjClose = new Date(tClose);
                this.orderData[i].close_time = dateObjClose;
              }
              if (this.orderData[i].status_updated_time !== "") {
                var dateObjOpen = moment
                  .utc(this.orderData[i].status_updated_time)
                  .toDate();
                this.orderData[i].status_updated_time = dateObjOpen;
              }
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }
  clearSearch() {
    this.pageOrder = 0;
    this.searchOrderString = "";
    this.searchAllOrders();
  }
  getOrderListByPageFunction() {
    this.Paginationdisable = true;
    // this.pageOrder = 0;
    this.paginatedDataOrder = [];
    // this.pageOrder++;
    if (this.searchOrderString === "") {
      this.pageOrder++;
      this.nao.go(30);
      console.log("login data 2");
      var cityId = "-1";
      if (this.serviceName != "Services - All") {
        cityId = this.serviceName;
      }
      this.dataService
        .getOrderListByPage(
          window.localStorage.getItem("token"),
          this.pageOrder,
          this.orderStatus,
          this.limitOrders,
          cityId,
          this.dispensary_id,
          this.outletId,
          this.outletDayindex,
          this.selectionDayOpenTime,
          this.selectionDayCloseTime,
          this.orderId
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            this.paginatedDataOrder = data;
            console.log("load More Data", this.paginatedDataOrder);
            // this.limit = this.paginatedData.limit;
            this.last_pageOrder = this.paginatedDataOrder.last_page;
            this.paginatedDataOrder = this.paginatedDataOrder.items;
            // this.pageOrder++;
            this.Paginationdisable = false;

            for (var i = 0; i < this.paginatedDataOrder.length; i++) {
              var cDate = new Date().getDate();
              var cYear = new Date().getFullYear();
              var cMonth = new Date().getUTCMonth() + 1;
              var openTime = this.paginatedDataOrder[i].open_time;
              var tOpen =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                openTime +
                " " +
                "UTC";
              var dateObjOpen = new Date(tOpen);
              this.paginatedDataOrder[i].open_time = dateObjOpen;

              var closeTime = this.paginatedDataOrder[i].close_time;
              var tClose =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                closeTime +
                " " +
                "UTC";
              var dateObjClose = new Date(tClose);
              this.paginatedDataOrder[i].close_time = dateObjClose;

              if (this.paginatedDataOrder[i].status_updated_time !== "") {
                var dateObjOpen = moment
                  .utc(this.paginatedDataOrder[i].status_updated_time)
                  .toDate();
                this.paginatedDataOrder[i].status_updated_time = dateObjOpen;
              }
              this.orderData.push(this.paginatedDataOrder[i]);
            }

            if (this.orderStatus === 2) {
              // this.clearMarker();
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    } else {
      var cityId = "-1";
      if (this.serviceName != "Services - All") {
        cityId = this.serviceName;
      }
      this.pageOrder++;
      this.nao.go(30);
      console.log("login data 3");
      this.dataService
        .getOrderSearchListByPage(
          window.localStorage.getItem("token"),
          this.searchOrderString,
          this.pageOrder,
          this.orderStatus,
          this.limitOrders,
          cityId,
          this.dispensary_id,
          this.outletId,
          this.outletDayindex,
          this.selectionDayOpenTime,
          this.selectionDayCloseTime
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            this.paginatedDataOrder = data;
            // this.limit = this.paginatedData.limit;
            this.last_pageOrder = this.paginatedDataOrder.last_page;
            this.paginatedDataOrder = this.paginatedDataOrder.items;
            for (var i = 0; i < this.paginatedDataOrder.length; i++) {
              var cDate = new Date().getDate();
              var cYear = new Date().getFullYear();
              var cMonth = new Date().getUTCMonth() + 1;
              var openTime = this.paginatedDataOrder[i].open_time;
              var tOpen =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                openTime +
                " " +
                "UTC";
              var dateObjOpen = new Date(tOpen);
              this.paginatedDataOrder[i].open_time = dateObjOpen;

              var closeTime = this.paginatedDataOrder[i].close_time;
              var tClose =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                closeTime +
                " " +
                "UTC";
              var dateObjClose = new Date(tClose);
              this.paginatedDataOrder[i].close_time = dateObjClose;

              if (this.paginatedDataOrder[i].status_updated_time !== "") {
                var dateObjOpen = moment
                  .utc(this.paginatedDataOrder[i].status_updated_time)
                  .toDate();
                this.paginatedDataOrder[i].status_updated_time = dateObjOpen;
              }
              this.orderData.push(this.paginatedDataOrder[i]);
            }
            // this.pageOrder++;
            for (var i = 0; i < this.paginatedDataOrder.length; i++) {
              this.orderData.push(this.paginatedDataOrder[i]);
            }
            if (this.orderStatus === 2) {
              // this.clearMarker();
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }
  }
  getBatcheslist() {
    // if ( this.outletId === -1 ){
    //   this.outletId = this.outletData[0].id;
    //   this.outletName = this.outletData[0].name;
    // }
    this.dataService
      .getBatch(
        window.localStorage.getItem("token"),
        this.outletId,
        this.outletDayindex,
        this.selectionDayOpenTime,
        this.selectionDayCloseTime
      )
      .subscribe(
        (data) => {
          this.getBatchData = data;
          // this.limit = 2;
          this.last_page = this.getBatchData.last_page;
          this.pageLoad++;
          this.getBatchData = this.getBatchData.items;
          // this.OrderList = this.getBatchData[0].order_list[0].tracking_id;
          // console.log('this.OrderList', this.OrderList);
        },
        (error) => {
          console.log("error", error);
        }
      );
  }
  getBatcheslistBySearch() {
    clearTimeout(this.clearTimeoutBatch);
    this.clearTimeoutBatch = setTimeout(() => {
      // this.nao.go(30);
      this.getBatchData = [];
      this.pageLoad = 0;
      this.dataService
        .searchBatch(
          window.localStorage.getItem("token"),
          this.batchSearch,
          this.outletId,
          this.outletDayindex,
          this.selectionDayOpenTime,
          this.selectionDayCloseTime
        )
        .subscribe(
          (data) => {
            // this.nao.go(100);
            this.getBatchData = data;
            // this.limit = 2;
            this.last_page = this.getBatchData.last_page;
            this.pageLoad++;
            this.getBatchData = this.getBatchData.items;
          },
          (error) => {
            // this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }
  clearSearchBatch() {
    this.batchSearch = "";
    this.getBatcheslist();
  }
  getBatchListByPageFunction() {
    this.Paginationdisable = true;
    this.nao.go(30);
    console.log("login data 4");
    this.dataService
      .getBatchByPage(
        window.localStorage.getItem("token"),
        this.pageLoad,
        this.outletId,
        this.outletDayindex,
        this.selectionDayOpenTime,
        this.selectionDayCloseTime
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginatedData = data;
          // this.limit = this.paginatedData.limit;
          this.last_page = this.paginatedData.last_page;
          this.paginatedData = this.paginatedData.items;
          this.pageLoad++;
          this.Paginationdisable = false;
          // this.paging = false;
          // this.once = false;
          // this.paging_once = false;
          for (var i = 0; i < this.paginatedData.length; i++) {
            this.getBatchData.push(this.paginatedData[i]);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  clearMarker() {
    console.log("this.packedDataArray", this.orderData);
    this.chRef.detectChanges();
    for (var i = 0; i < this.marker.length; i++) {
      this.marker[i].setMap(null);
      this.marker.splice(i, 1);
    }
    var context = this;
    var endImage = {
      url: "assets/pin-green.png", // url
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16), // anchorr
    };
    setTimeout(() => {
      this.chRef.detectChanges();
      let mapEle = this.mapElement.nativeElement;
      this.map = new google.maps.Map(mapEle, {
        zoom: 10,
        center: {
          lat: this.orderData[0].latitude,
          lng: this.orderData[0].logitude,
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        zoomControl: true,
        scaleControl: true,
      });
      google.maps.event.addListenerOnce(this.map, "idle", () => {
        mapEle.classList.add("show-map");
      });
      for (var i = 0; i < this.orderData.length; i++) {
        // if (this.orderData[i].order_status === 2) {
        console.log("i", i);
        var bounds = new google.maps.LatLngBounds();
        var location = new google.maps.LatLng(
          this.orderData[i].latitude,
          this.orderData[i].logitude
        );
        bounds.extend(location);
        this.marker[i] = new google.maps.Marker({
          title: " Order #" + context.orderData[i].order_no,
          position: location,
          map: this.map,
          icon: endImage,
          zoom: 5,
        });
        this.infowindow[i] = new google.maps.InfoWindow();
        // context.infowindow[context.i].setContent(context.marker[context.i].title);
        // context.infowindow[context.i].open(context.map, context.marker[context.i]);
        (function (i) {
          if (context.orderData[i].delivery_man_type === 3) {
            return;
          }
          google.maps.event.addListener(
            context.marker[i],
            "click",
            function () {
              // console.log('info window chk', i);
              context.infowindow[i].setContent(context.marker[i].title);
              context.infowindow[i].open(context.map, context.marker[i]);
              var blue = {
                url: "assets/pin-green-solid.png", // url
                scaledSize: new google.maps.Size(30, 30), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(16, 16), // anchor
              };
              var green = {
                url: "assets/pin-green.png", // url
                scaledSize: new google.maps.Size(30, 30), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(16, 16), // anchor
              };
              //  batch Start on marker click
              if ($("#chk" + i).prop("checked") !== true) {
                // $('#chk' + i).prop('checked', true);
                // context.marker[i].setIcon(blue);
                context.marker[i].setIcon(blue);
                // context.map.panTo(context.marker[i].position);
                context.infowindow[i].open(context.map, context.marker[i]);
                $("#chk" + i).prop("checked", true);
                context.batchArray.push({
                  order_id: context.orderData[i].order_id,
                });
                // console.log('order_id: context.orderData[i].order_id', context.orderData[i].order_id, context.batchArray);
                // console.log('index blue', i);
              } else {
                $("#chk" + i).prop("checked", false);
                context.marker[i].setIcon(green);
                context.infowindow[i].close();
                // var removeElement = context.batchArray.indexOf(context.orderData[i].order_id);
                // console.log('index green', removeElement);
                for (var j = 0; j < context.batchArray.length; j++) {
                  if (
                    context.batchArray[j].order_id ===
                    context.orderData[i].order_id
                  ) {
                    // var removeElement = context.batchArray.indexOf(context.orderData[index].order_id);
                    context.batchArray.splice(j, 1);
                  }
                }
                //  context.batchArray.splice(removeElement, 1);
                // console.log('this.batchArray false', context.batchArray);
              }
              if (context.batchArray.length > 0) {
                context.batchBtn = true;
                // this.chRef.detectChanges();
                setTimeout(() => {
                  context.chRef.detectChanges();
                }, 100);
                // console.log('context.batchArray.length', true);
              } else {
                context.batchBtn = false;
                // console.log('context.batchArray.length', false);
                // this.chRef.detectChanges();
                setTimeout(() => {
                  context.chRef.detectChanges();
                }, 100);
              }

              //  batch end on marker click
            }
          );
        })(i);
      }
      var mc = new MarkerClusterer(context.map, context.marker, {
        imagePath: "assets/m",
        zoom: 5,
        zoomOnClick: false,
      });
      // Marker cluster click handling for selection
      google.maps.event.addListener(mc, "clusterclick", function (cluster) {
        var count = 0;
        console.log("cluster", cluster);
        for (var j = 0; j < cluster.markers_.length; j++) {
          var id = cluster.markers_[j].title;
          id = id.split("#")[1];
          for (var a = 0; a < context.orderData.length; a++) {
            if (context.orderData[a].order_no === id) {
              if ($("#chk" + a).prop("checked") === true) {
                count++;
              }
            }
          }
        }
        for (var j = 0; j < cluster.markers_.length; j++) {
          if (context.orderData[i].delivery_man_type !== 3) {
            var id = cluster.markers_[j].title;
            id = id.split("#")[1];
            var blue = {
              url: "assets/pin-green-solid.png", // url
              scaledSize: new google.maps.Size(30, 30), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            var green = {
              url: "assets/pin-green.png", // url
              scaledSize: new google.maps.Size(30, 30), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            if (count === cluster.markers_.length) {
              for (var i = 0; i < context.orderData.length; i++) {
                if (context.orderData[i].order_no === id) {
                  // console.log('chk', i);
                  context.infowindow[i].close();
                  $("#chk" + i).prop("checked", false);
                  context.marker[i].setIcon(green);
                  context.infowindow[i].close();
                  // for(var k = 0; k < context.batchArray.length; k++) {
                  //   // for (var t = 0; t < context.orderData.length; t++) {
                  //     if (context.batchArray[k].order_id === context.orderData[i].order_id) {
                  //       context.batchArray.splice(k, 1);
                  //     }
                  //   // }
                  // }
                  for (var k = 0; k < context.batchArray.length; k++) {
                    if (
                      context.batchArray[k].order_id ===
                      context.orderData[i].order_id
                    ) {
                      context.batchArray.splice(k, 1);
                    }
                  }
                  // if (value === false) {
                  //   context.batchArray.push({
                  //     order_id: context.orderData[i].order_id
                  //   });
                  // }
                }
              }
            } else {
              console.log(
                "in else else else else else else else else else else else else else else else else else"
              );
              for (var i = 0; i < context.orderData.length; i++) {
                if (context.orderData[i].delivery_man_type !== 3) {
                  if (context.orderData[i].order_no === id) {
                    context.infowindow[i] = new google.maps.InfoWindow();
                    context.infowindow[i].close();
                    context.infowindow[i].setContent(context.marker[i].title);
                    context.infowindow[i].open(context.map, context.marker[i]);
                    context.marker[i].setIcon(blue);
                    // context.map.panTo(context.marker[i].position);
                    $("#chk" + i).prop("checked", true);
                    let value = false;
                    for (var k = 0; k < context.batchArray.length; k++) {
                      // for (var t = 0; t < context.orderData.length; t++) {
                      if (
                        context.batchArray[k].order_id ===
                        context.orderData[i].order_id
                      ) {
                        value = true;
                        break;
                      }
                      // }
                    }
                    if (value === false) {
                      context.batchArray.push({
                        order_id: context.orderData[i].order_id,
                      });
                    }
                  }
                }
              }
            }
            if (context.batchArray.length > 0) {
              context.batchBtn = true;
              // this.chRef.detectChanges();
              setTimeout(() => {
                context.chRef.detectChanges();
              }, 100);
            } else {
              context.batchBtn = false;
              // this.chRef.detectChanges();
              setTimeout(() => {
                context.chRef.detectChanges();
              }, 100);
            }
          }
        }
        console.log("batch array", context.batchArray);
      });
      // })(i);
      // }
    }, 2000);
  }
  orderStatusChange(id, name, index, invoice_id) {
    $(".processOrderNewImg" + index).css("display", "none"); // hide process img to show loader
    $("#procesLoader" + index).css("display", "inline-block"); // show loader
    $(".deliveryReady" + index).css("display", "none");
    $("#deliveryReady" + index).css("display", "inline-block");
    // console.log( $('#procesLoader' + index).css('display', 'inline-block'););

    // this.nao.go(30);
    this.dataService
      .orderStatus(window.localStorage.getItem("token"), id, invoice_id)
      .subscribe(
        (data) => {
          // this.nao.go(100);
          console.log("orders data", data);
          $(".processOrderNewImg" + index).css("display", "inline-block");
          $("#procesLoader" + index).css("display", "none");
          $(".deliveryReady" + index).css("display", "none");
          $("#deliveryReady" + index).css("display", "inline-block");
          this.orderData = data;
          console.log("this.orderData", this.orderData);
          // $('#displayNone').css('display', 'none');
          this.success = this.orderData.success;
          this.error = this.orderData.message;
          this.orderData = this.orderData.items;

          // console.log('this.orderData', this.orderData);ƒ
          if (this.success === true) {
            // $("#click-me-div").click(function() {
            //  alert('yes, the click actu y happened');
            $(".clear").removeClass("active");
            $("#" + name).addClass("active");
            $("#" + name).addClass("in");
            if (name === "packaging") {
              $("#1").addClass("active");
              this.orderslist(1);
            }
            if (name === "packed") {
              $("#2").addClass("active");
              this.orderslist(2);
              // setTimeout(() => {
              //   this.clearMarker();
              // }, 3000);
              this.chRef.detectChanges();
            }

            // });
          } else {
            if (this.success == false) {
              toastr.error(this.error);
            }
          }
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  // filterOrders(value) {
  //   this.query = [];
  //   for (var i = 0; i < this.orderData.length; i++) {
  //     if (this.orderData[i].order_status === value) {
  //       this.query.push(this.orderData[i]);
  //     }
  //   }
  //   return this.query;
  // }

  batchDetailFunction(id) {
    setTimeout(() => {
      this.chRef.detectChanges();
    }, 100);
    this.nao.go(30);
    this.customRemovableArray = [];
    this.detailTotalCharges = 0;
    // this.lengthCount = 1;
    this.batchDetailId = id;
    var context = this;
    for (var i = 0; i < this.markerDrop.length; i++) {
      this.markerDrop[i].setMap(null);
      this.markerDrop.splice(i, 1);
    }
    for (var j = 0; j < this.marker2.length; j++) {
      this.marker2[j].setMap(null);
      this.marker2.splice(i, 1);
    }
    this.dataService
      .getbatchDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          // console.log('orders data', data);
          this.detailData = data;
          this.batchId = this.detailData.batch_id;
          this.detailDataSuccess = this.detailData.success;
          this.detailData = this.detailData.items;
          this.detailDataLength = this.detailData.length;
          console.log("detailDataLength", this.detailDataLength);
          for (var i = 0; i < this.detailData.length; i++) {
            this.customRemovableArray.push({
              order_id: this.detailData[i].order_id,
              is_remove: false,
            });
            // this.lengthCount = this.lengthCount + i;
            this.detailTotalCharges =
              this.detailTotalCharges + this.detailData[i].charges;
          }
          this.lengthCount = this.detailData.length;
          console.log("detailData", this.detailData);
          this.selectedDriverName = "";
          this.searchStringCustomer = "";
          this.hideDriverFindField = false;
          setTimeout(() => {
            this.chRef.detectChanges();
            this.mapEle2 = this.mapElement2.nativeElement;
            this.map2 = new google.maps.Map(this.mapEle2, {
              zoom: 13,
              center: {
                lat: this.detailData[0].latitude,
                lng: this.detailData[0].longitude,
              },
              mapTypeId: google.maps.MapTypeId.ROADMAP,
              disableDefaultUI: true,
              zoomControl: true,
              scaleControl: true,
            });
            google.maps.event.addListenerOnce(this.map2, "idle", () => {
              this.mapEle2.classList.add("show-map");
            });
            var endImage = {
              url: "assets/drop_pin-bucket.png", // url
              scaledSize: new google.maps.Size(50, 56), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            var orderDeliveryIcon = {
              url: "assets/pin-green.png", // url
              scaledSize: new google.maps.Size(30, 30), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            var deliveryDriverIcon = {
              url: "assets/new-van.png", // url
              scaledSize: new google.maps.Size(40, 46), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            setTimeout(() => {
              for (var i = 0; i < this.availableDriverData.length; i++) {
                if (
                  (this.availableDriverData[i].is_on_job === true ||
                    this.availableDriverData[i].is_available === true) &&
                  this.availableDriverData[i].is_online === true
                ) {
                  console.log(
                    "this.availableDrivers[i].latitude, this.availableDrivers[i].longitude",
                    this.availableDriverData[i].latitude,
                    this.availableDriverData[i].longitude
                  );
                  var boundsDriver = new google.maps.LatLngBounds();
                  var locationDriver = new google.maps.LatLng(
                    this.availableDriverData[i].latitude,
                    this.availableDriverData[i].longitude
                  );
                  boundsDriver.extend(locationDriver);
                  this.markerDrivers[i] = new google.maps.Marker({
                    position: locationDriver,
                    map: this.map2,
                    icon: deliveryDriverIcon,
                    zoom: 13,
                  });
                }
              }
            }, 1500);
            for (var i = 0; i < this.detailData.length; i++) {
              var bounds2 = new google.maps.LatLngBounds();
              var location = new google.maps.LatLng(
                this.detailData[i].pickup_latitude,
                this.detailData[i].pickup_longitude
              );
              bounds2.extend(location);
              this.marker2[i] = new google.maps.Marker({
                position: location,
                map: this.map2,
                icon: endImage,
                zoom: 13,
              });
              var boundsOrder = new google.maps.LatLngBounds();
              var locationOrder = new google.maps.LatLng(
                this.detailData[i].latitude,
                this.detailData[i].longitude
              );
              boundsOrder.extend(locationOrder);
              this.markerDrop[i] = new google.maps.Marker({
                position: locationOrder,
                map: this.map2,
                title: " Order #" + context.detailData[i].order_id,
                icon: orderDeliveryIcon,
                zoom: 13,
              });
              (function (i) {
                google.maps.event.addListener(
                  context.markerDrop[i],
                  "click",
                  function () {
                    console.log("info window chk", i);
                    var blue = {
                      url: "assets/pin-green-solid.png", // url
                      scaledSize: new google.maps.Size(30, 30), // scaled size
                      origin: new google.maps.Point(0, 0), // origin
                      anchor: new google.maps.Point(16, 16), // anchor
                    };
                    var green = {
                      url: "assets/pin-green.png", // url
                      scaledSize: new google.maps.Size(30, 30), // scaled size
                      origin: new google.maps.Point(0, 0), // origin
                      anchor: new google.maps.Point(16, 16), // anchor
                    };
                    if ($("#removeChk" + i).prop("checked") !== true) {
                      context.markerDrop[i].setIcon(blue);
                      context.map2.panTo(context.markerDrop[i].position);
                      $("#removeChk" + i).prop("checked", true);
                      console.log("index blue", i);
                    } else {
                      $("#removeChk" + i).prop("checked", false);
                      context.markerDrop[i].setIcon(green);
                      console.log("this.batchArray false");
                    }
                    context.removeBatchSelection(this.order_id, i);
                  }
                );
              })(i);
            }
            this.availableDriverlist(id);
          }, 1000);
          $("#bookModal").modal("show");
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  searchDriverOnOrder() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.nao.go(30);
      console.log("login data 5");
      this.dataService
        .searchDriverListInBatch(
          window.localStorage.getItem("token"),
          this.searchStringCustomer,
          "order_string",
          this.batchId
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            console.log("products data", data);
            if (this.searchStringCustomer === "") {
              this.driverData = [];
              this.driverDataLength = undefined;
            } else {
              this.driverData = data;
              this.driverData = this.driverData.items;
              this.driverDataLength = this.driverData.length;
              for (var i = 0; i < this.driverData.length; i++) {
                if (this.driverData[i].country_code === "+1") {
                  this.driverData[i].phone_number = format(
                    this.driverData[i].number,
                    "US",
                    "NATIONAL"
                  );
                  console.log(
                    "this.driverData[i].number",
                    this.driverData[i].number
                  );
                }
              }
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }
  selectCustomer(id, name) {
    this.driverId = id;
    this.selectedDriverName = name;
    this.hideDriverFindField = true;
    for (var i = 0; i < this.runningDrivers.length; i++) {
      if (this.runningDrivers[i].id === id) {
        console.log("this.runningDrivers[i].id", this.runningDrivers[i].id, id);
        console.log("index", i);
        $(".clearDriverBox").prop("checked", false);
        $("#runningDriver" + i).prop("checked", true);
      }
    }
    for (var j = 0; j < this.availableDrivers.length; j++) {
      if (this.availableDrivers[j].id === id) {
        console.log(
          "this.availableDrivers[j].id",
          this.availableDrivers[j].id,
          id
        );
        console.log("index", j);
        $(".clearDriverBox").prop("checked", false);
        $("#availableDriver" + j).prop("checked", true);
      }
    }
  }
  selectDriverFromChkBox(id, name, index) {
    // $('.clearDriverBox').prop('checked', false);
    // console.log('chk chk', $('#availableDriver' + index).prop('checked'));
    if ($("#availableDriver" + index).prop("checked") === true) {
      $(".clearDriverBox").prop("checked", false);
      $("#availableDriver" + index).prop("checked", true);
      console.log("in if");
      this.selectCustomer(id, name);
    } else {
      $(".clearDriverBox").prop("checked", false);
      console.log("in else");
      this.hideDriver();
    }
  }
  selectRunningDriverFromChkBox(id, name, index) {
    // $('.clearDriverBox').prop('checked', false);
    // console.log('chk chk', $('#availableDriver' + index).prop('checked'));
    if ($("#runningDriver" + index).prop("checked") === true) {
      $(".clearDriverBox").prop("checked", false);
      $("#runningDriver" + index).prop("checked", true);
      console.log("in if");
      this.selectCustomer(id, name);
    } else {
      $(".clearDriverBox").prop("checked", false);
      console.log("in else");
      this.hideDriver();
    }
  }
  hideDriver() {
    this.hideDriverFindField = false;
    this.selectedDriverName = "";
    this.driverId = undefined;
    this.searchStringCustomer = "";
    $(".clearDriverBox").prop("checked", false);
  }
  bookOrderFunction() {
    this.isDisableOrderBtn = true;
    console.log("driver chk", this.driverId);
    if (this.driverId === undefined) {
      toastr.error("Please select a driver");
      return;
    }
    this.nao.go(30);
    console.log("login data 6");
    this.dataService
      .bookOrder(
        window.localStorage.getItem("token"),
        this.batchId,
        this.driverId
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.bookorderdata = data;
          this.bookOrderMessage = this.bookorderdata.message;
          this.bookOrderSuccess = this.bookorderdata.success;
          if (this.bookOrderSuccess === true) {
            this.isDisableOrderBtn = false;
            this.orderslist(3);
            this.getBatcheslist();
            this.selectedDriverName = "";
            this.searchStringCustomer = "";
            this.hideDriverFindField = false;
            $("#bookModal").modal("hide");
            $(".clear").removeClass("active");
            $("#3").addClass("active");
            $("#booked").addClass("active");
            $("#booked").addClass("in");
          }
          if (this.bookOrderSuccess === false) {
            toastr.error(this.bookOrderMessage);
            this.selectedDriverName = "";
            this.searchStringCustomer = "";
            this.hideDriverFindField = false;
            this.isDisableOrderBtn = false;
            $(".clearDriverBox").prop("checked", false);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  availableDriverlist(batch_id) {
    this.nao.go(30);
    this.availableDrivers = [];
    this.runningDrivers = [];
    this.dataService
      .getDriverListInBatch(window.localStorage.getItem("token"), batch_id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.availableDriverData = data;
          console.log("avalible drivers");
          this.availableDriverData = this.availableDriverData.items;
          for (var i = 0; i < this.availableDriverData.length; i++) {
            if (
              this.availableDriverData[i].is_available === true &&
              this.availableDriverData[i].is_online === true
            ) {
              this.availableDrivers.push(this.availableDriverData[i]);
            }
            if (
              this.availableDriverData[i].is_on_job === true &&
              this.availableDriverData[i].is_online === true
            ) {
              this.runningDrivers.push(this.availableDriverData[i]);
            }
          }
          this.showAvailability = true;
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  batchFunction(id, delivery_man_type, index) {
    if (delivery_man_type === 3) {
      console.log("1");
      $("#chk" + index).prop("checked", false);
      return;
    }
    // setTimeout(() => { this.chRef.detectChanges(); }, 100);
    // if ($('#chk' + index).prop('checked') === true) {
    // for (var i = 0; i < this.orderData.length; i++) {
    //   if (this.orderData[i].order_id === id) {
    //     this.batchArray.push({
    //       order_id: id
    //     });
    //   }
    // }
    // console.log('this.batchArray true', this.batchArray);
    // } else {
    //   var removeElement = this.batchArray.indexOf(id);
    //  this.batchArray.splice(removeElement, 1);
    //  console.log('this.batchArray false', this.batchArray);
    // }
    // console.log('this.batchArray.length', this.batchArray.length);
    // if (this.batchArray.length > 0) {
    // this.batchBtn = true;
    // } else {
    //   this.batchBtn = false;
    // }

    var context = this;
    // context.infowindow[index].setContent(context.marker[index].title);
    // context.infowindow[index].open(context.map, context.marker[index]);
    // var blue = {
    //   url: 'assets/pin-green-solid.png', // url
    //   scaledSize: new google.maps.Size(30, 30), // scaled size
    //   origin: new google.maps.Point(0, 0), // origin
    //   anchor: new google.maps.Point(16, 16) // anchor
    // };
    // var green = {
    //   url: 'assets/pin-green.png', // url
    //   scaledSize: new google.maps.Size(30, 30), // scaled size
    //   origin: new google.maps.Point(0, 0), // origin
    //   anchor: new google.maps.Point(16, 16) // anchor
    // };
    //  batch Start on marker click
    if ($("#chk" + index).prop("checked") === true) {
      // $('#chk' + i).prop('checked', true);
      // context.marker[i].setIcon(blue);
      // context.marker[index].setIcon(blue);
      // context.map.panTo(context.marker[index].position);
      // context.infowindow[index].open(context.map, context.marker[index]);
      $("#chk" + index).prop("checked", true);
      context.batchArray.push({
        order_id: context.orderData[index].order_id,
      });
      console.log(
        "order_id: context.orderData[i].order_id",
        context.orderData[index].order_id,
        context.batchArray
      );
    } else {
      $("#chk" + index).prop("checked", false);
      // context.marker[index].setIcon(green);
      // context.infowindow[index].close();
      for (var j = 0; j < this.batchArray.length; j++) {
        if (this.batchArray[j].order_id === context.orderData[index].order_id) {
          // var removeElement = context.batchArray.indexOf(context.orderData[index].order_id);
          context.batchArray.splice(j, 1);
        }
      }
      // console.log('index chk', removeElement);
      console.log("this.batchArray false", context.batchArray);
      // console.log('this.batchArray remove', removeElement);
    }
    if (context.batchArray.length > 0) {
      context.batchBtn = true;
      // this.chRef.detectChanges();
      setTimeout(() => {
        context.chRef.detectChanges();
      }, 100);
      console.log("context.batchArray.length", true);
    } else {
      context.batchBtn = false;
      console.log("context.batchArray.length", false);
      // this.chRef.detectChanges();
      setTimeout(() => {
        context.chRef.detectChanges();
      }, 100);
    }
  }
  deliverOrder(id, type, index) {
    this.nao.go(30);
    let data = {
      auth_token: window.localStorage.getItem("token"),
      order_id: id,
      status: 5,
      version_number: null,
    };
    this.dataService.changeOrderStatus(data).subscribe(
      (data) => {
        this.nao.go(70);
        this.delivered = data;
        if (this.delivered.success == true) {
          toastr.success("Order Successfully delivered");
          this.orderslist(5);
          $(".clear").removeClass("active");
          $("#delivered").addClass("active");
          $("#5").addClass("active");
          $("#delivered").addClass("in");
        }
        this.nao.go(100);
      },
      (error) => {
        this.nao.go(100);
        console.log(error);
      }
    );
  }
  createBatchfunction() {
    this.isDisable = true;
    this.chRef.detectChanges();
    this.nao.go(30);
    console.log("login data 7");

    this.dataService
      .createBatchOrders(window.localStorage.getItem("token"), this.batchArray)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.createBatchData = data;
          this.error = this.createBatchData.message;
          if (this.createBatchData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.createBatchData.rest_error_code === 2)
            toastr.error("Please login again");
          this.createBatchData = this.createBatchData.success;

          console.log("batch message", this.createBatchData.message);
          if (this.createBatchData === true) {
            toastr.success("Batch created successfully");
            this.batchBtn = false;
            this.isDisable = false;
            // this.orderslist();
            this.getBatcheslist();
            setTimeout(() => {
              this.chRef.detectChanges();
            }, 100);
            this.batchArray = [];
            $(".clearChk").prop("checked", false);
            $(".clear").removeClass("active");
            $("#batches").addClass("active");
            $("#8").addClass("active");
            $("#batches").addClass("in");
            setTimeout(() => {
              // this.clearMarker();
              this.chRef.detectChanges();
            }, 3000);
          } else {
            if (this.createBatchData === false) {
              toastr.error(this.error);
              this.batchBtn = true;
              this.isDisable = false;
            }
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  removeBatchSelection(id, index) {
    setTimeout(() => {
      this.chRef.detectChanges();
    }, 100);
    this.customRemovableArray = [];
    for (var i = 0; i < this.detailData.length; i++) {
      if ($("#removeChk" + i).prop("checked") === true) {
        this.customRemovableArray.push({
          order_id: this.detailData[i].order_id,
          is_remove: true,
        });
      } else {
        this.customRemovableArray.push({
          order_id: this.detailData[i].order_id,
          is_remove: false,
        });
      }
    }
    var count = 0;
    for (var i = 0; i < this.customRemovableArray.length; i++) {
      if ($("#removeChk" + i).prop("checked") === true) {
        count = count + 1;
      }
    }
    console.log("customRemovableArray", this.customRemovableArray);
    if (count > 0) {
      this.removeBatchorderBtn = false;
    } else {
      this.removeBatchorderBtn = true;
    }
  }
  removeMarkerSelectionForBook(index) {
    var context = this;
    var blue = {
      url: "assets/pin-green-solid.png", // url
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16), // anchor
    };
    var green = {
      url: "assets/pin-green.png", // url
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 16), // anchor
    };
    //  batch Start on marker click
    if ($("#removeChk" + index).prop("checked") === true) {
      // $('#chk' + i).prop('checked', true);
      // context.marker[i].setIcon(blue);
      context.markerDrop[index].setIcon(blue);
      context.map2.panTo(context.markerDrop[index].position);
      // context.infowindow[i].open(context.map, context.markerDrop[i]);
      // $('#removeChk' + index).prop('checked', true);
      // console.log('order_id: context.orderData[i].order_id', context.orderData[i].order_id, context.batchArray);
      console.log("index blue", index);
    } else {
      // $('#removeChk' + index).prop('checked', false);
      context.markerDrop[index].setIcon(green);
      // context.infowindow[i].close();
      // var removeElement = context.batchArray.indexOf(context.orderData[i].order_id);
      // console.log('index green', removeElement);
      //  context.batchArray.splice(removeElement, 1);
      console.log("this.batchArray false");
    }
  }

  removeBatchFunction() {
    this.nao.go(30);
    this.removeBatchorderBtn = true;
    console.log("login data 8");
    this.dataService
      .removeBatch(
        window.localStorage.getItem("token"),
        this.batchId,
        this.customRemovableArray,
        0
      )
      .subscribe(
        (data) => {
          // this.batchDetailFunction(this.batchDetailId);
          // $('#bookModal').modal('hide');
          // this.orderslist();
          this.getBatcheslist();
          // this.clearMarker();
          this.batchDetailFunction(this.batchDetailId);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  editBatchFunction() {
    this.nao.go(30);
    this.customRemovableArray = [];
    for (var i = 0; i < this.detailData.length; i++) {
      if ($("#removeChk" + i).prop("checked") === true) {
        this.customRemovableArray.push({
          order_id: this.detailData[i].order_id,
          is_remove: true,
        });
      } else {
        this.customRemovableArray.push({
          order_id: this.detailData[i].order_id,
          is_remove: false,
        });
      }
    }
    var context = this;
    this.removeBatchorderBtn = true;
    console.log("login data 9", this.customRemovableArray);
    this.dataService
      .removeBatch(
        window.localStorage.getItem("token"),
        this.batchId,
        this.customRemovableArray,
        1
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.getBatcheslist();
          let id = this.batchId;
          setTimeout(() => {
            this.chRef.detectChanges();
            this.mapEle2 = this.mapElement2.nativeElement;
            this.map2 = new google.maps.Map(this.mapEle2, {
              zoom: 13,
              center: {
                lat: this.detailData[0].latitude,
                lng: this.detailData[0].longitude,
              },
              mapTypeId: google.maps.MapTypeId.ROADMAP,
              disableDefaultUI: true,
              zoomControl: true,
              scaleControl: true,
            });
            google.maps.event.addListenerOnce(this.map2, "idle", () => {
              this.mapEle2.classList.add("show-map");
            });
            var endImage = {
              url: "assets/drop_pin-bucket.png", // url
              scaledSize: new google.maps.Size(50, 56), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            var orderDeliveryIcon = {
              url: "assets/pin-green.png", // url
              scaledSize: new google.maps.Size(30, 30), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            var deliveryDriverIcon = {
              url: "assets/new-van.png", // url
              scaledSize: new google.maps.Size(40, 46), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(16, 16), // anchor
            };
            for (var i = 0; i < this.detailData.length; i++) {
              var bounds2 = new google.maps.LatLngBounds();
              var location = new google.maps.LatLng(
                this.detailData[i].pickup_latitude,
                this.detailData[i].pickup_longitude
              );
              bounds2.extend(location);
              this.marker2[i] = new google.maps.Marker({
                position: location,
                map: this.map2,
                icon: endImage,
                zoom: 13,
              });
              var boundsOrder = new google.maps.LatLngBounds();
              var locationOrder = new google.maps.LatLng(
                this.detailData[i].latitude,
                this.detailData[i].longitude
              );
              boundsOrder.extend(locationOrder);
              this.markerDrop[i] = new google.maps.Marker({
                position: locationOrder,
                map: this.map2,
                title: " Order #" + context.detailData[i].order_id,
                icon: orderDeliveryIcon,
                zoom: 13,
              });
              (function (i) {
                google.maps.event.addListener(
                  context.markerDrop[i],
                  "click",
                  function () {
                    console.log("info window chk", i);
                    var blue = {
                      url: "assets/pin-green-solid.png", // url
                      scaledSize: new google.maps.Size(30, 30), // scaled size
                      origin: new google.maps.Point(0, 0), // origin
                      anchor: new google.maps.Point(16, 16), // anchor
                    };
                    var green = {
                      url: "assets/pin-green.png", // url
                      scaledSize: new google.maps.Size(30, 30), // scaled size
                      origin: new google.maps.Point(0, 0), // origin
                      anchor: new google.maps.Point(16, 16), // anchor
                    };
                    if ($("#removeChk" + i).prop("checked") !== true) {
                      context.markerDrop[i].setIcon(blue);
                      context.map2.panTo(context.markerDrop[i].position);
                      $("#removeChk" + i).prop("checked", true);
                      console.log("index blue", i);
                    } else {
                      $("#removeChk" + i).prop("checked", false);
                      context.markerDrop[i].setIcon(green);
                      console.log("this.batchArray false");
                    }
                    context.removeBatchSelection(this.order_id, i);
                  }
                );
              })(i);
            }
            this.availableDriverlist(id);
          }, 500);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  // popOpen(id) {
  //   var data  = {
  //     token: window.localStorage.getItem('token'),
  //     order_id: id,
  //     version_number: 1.3,
  //   };
  //   $.ajax({
  //           type: 'POST',
  //           url: 'http://52.53.224.180/dispensary/get_order_detail',
  //           data: JSON.stringify(data),
  //           dataType: 'json',
  //           async: true,
  //           success: function (dataShow) {
  //             this.packaginInstrutionObj = dataShow;
  //             console.log('this.packaginInstrutionObj', this.packaginInstrutionObj);
  //           }
  //   });
  // }
  qrCodeGenerater(id) {
    this.dataService
      .getQrCode(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.qrCode = data;
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  packagingPrintFunction(id) {
    this.qrCodeGenerater(id);
    this.packaginInstrutionObj = new Array();
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.packaginInstrutionObj = data;
          this.dispensary_name =
            this.packaginInstrutionObj.pickup_address.dispensary_name;
          this.dispensary_image =
            this.packaginInstrutionObj.dispensary.business_image_url;
          // setTimeout(() => {
          console.log("pacaking", this.packaginInstrutionObj);
          // $('#packagePop').modal('show');
          // }, 2000);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  openpackagePop(): void {
    var context = this;
    let printContents, popupWin;
    context.printPopOpen = true;
    // const configuracion_ventana = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
    // 'height=400,width=800'
    setTimeout(() => {
      printContents = document.getElementById("DivIdToPrint");
      // var oldPage = document.body.innerHTML;
      popupWin = window.open("package pdrop_pinop", "", "height=400,width=800");
      popupWin.document.open();
      popupWin.document.write(
        '<html><body onload="window.print()">' +
          printContents.innerHTML +
          "</body></html>"
      );
      popupWin.document.close();
      // popupWin.close();
      // context.printPopOpen = false;
    }, 1000);
    setTimeout(function () {
      popupWin.close();
      context.printPopOpen = false;
    }, 1500);
  }
  bookedPrintFunction(id) {
    console.log(id);
    this.totalPacakgeQuantity = 0;
    this.totalPacakgeSaving = 0;
    this.qrCodeGenerater(id);
    this.packaginInstrutionObj = new Array();
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.packaginInstrutionObj = data;
          this.packagingProduct = this.packaginInstrutionObj.products;
          this.dispensary_name =
            this.packaginInstrutionObj.pickup_address.dispensary_name;
          this.dispensary_image =
            this.packaginInstrutionObj.dispensary.business_image_url;
          this.prodorderdisc = this.packaginInstrutionObj.order.discount;
          this.prodorderdelchar =
            this.packaginInstrutionObj.order.deliver_charges;
          this.prodordercharges = this.packaginInstrutionObj.order.taxes;
          this.prodordertotal = this.packaginInstrutionObj.order.total_price;
          this.prodordersubtotal = this.packaginInstrutionObj.order.sub_total;
          this.firstName =
            this.packaginInstrutionObj.customer_detail.first_name;
          this.get_invoice_id = this.packaginInstrutionObj.order.invoice_no;
          console.log("this.firstName", this.firstName);
          this.lastName = this.packaginInstrutionObj.customer_detail.last_name;
          console.log("this.lastName", this.lastName);

          for (var i = 0; i < this.packaginInstrutionObj.product.length; i++) {
            this.totalPacakgeQuantity =
              this.totalPacakgeQuantity +
              this.packaginInstrutionObj.product[i].quantity;
          }
          for (var j = 0; j < this.packaginInstrutionObj.product.length; j++) {
            this.totalPacakgeSaving =
              this.totalPacakgeSaving +
              (this.packaginInstrutionObj.product[j].sale_price -
                this.packaginInstrutionObj.product[j].unit_price);
          }

          if (
            this.firstName === null ||
            this.firstName === undefined ||
            this.firstName === "" ||
            this.lastName === null ||
            this.lastName === undefined ||
            this.lastName === ""
          ) {
          } else {
            this.bookPopOpen();
          }
          // for(var k = 0; k <= this.packagingProduct.length; k++) {
          //   this.totalSr = this.totalSr + 1;
          // }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  bookPopOpen() {
    var context = this;
    context.printPopOpen = true;
    setTimeout(function () {
      this.divToPrint2 = document.getElementById("bookedPrint");
      this.newWin2 = window.open(" ", "", "height=400,width=800");
      this.newWin2.document.open();
      this.newWin2.document.write(
        '<html><body onload="window.print()">' +
          this.divToPrint2.innerHTML +
          "</body></html>"
      );
      this.newWin2.document.close();
    }, 1000);
    // this.newWin2.close();
    setTimeout(function () {
      this.newWin2.close();
      context.printPopOpen = false;
    }, 1500);
  }
  manualtrackByAdmin() {
    var lat, lng, orderId;
    for (var i = 0; i <= this.trackDataOrder.length; i++) {
      console.log(
        "this.trackDataOrder[i].is_running",
        this.trackDataOrder[i].is_running
      );
      if (this.trackDataOrder[i].is_running === true) {
        lat = this.trackDataOrder[i].dropoff_latitude;
        lng = this.trackDataOrder[i].dropoff_longitude;
        orderId = this.trackDataOrder[i].order_id;
        break;
      }
    }
    this.nao.go(30);
    this.dataService
      .manualDropOff(
        window.localStorage.getItem("token"),
        orderId,
        this.trackDataDriver.id,
        lat,
        lng
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  trackOrderFunction(id) {
    this.nao.go(30);
    this.numberOfDriverLocationChecks = 0;
    this.currentDriverLocation = 0;
    this.dataService
      .trackOrder(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.trackData = data;
          this.trackDataDispensary = this.trackData.dispensary;
          this.trackDataDriver = this.trackData.driver;
          this.trackDataDriverIdForRoute = this.trackDataDriver.id;
          this.trackDataOrder = this.trackData.order_list;
          this.trackOrderId = this.trackDataOrder[0].order_id;
          // console.log('this.trackData', this.trackData);
          // console.log('this.trackDataDispensary', this.trackDataDispensary);
          // console.log('this.trackDataDriver', this.trackDataDriver);
          console.log("this.trackDataOrder", this.trackDataOrder);
          // console.log('this.trackOrderId', this.trackOrderId);
          let mapEleTrack = this.mapElement3.nativeElement;
          this.directionsService = new google.maps.DirectionsService();
          this.directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
          });
          this.directionsDisplay.setMap(this.mapTrack);
          this.mapTrack = new google.maps.Map(mapEleTrack, {
            zoom: 13,
            center: {
              lat: this.trackDataDriver.dropoff_latitude,
              lng: this.trackDataDriver.dropoff_longitude,
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            zoomControl: true,
            scaleControl: true,
          });
          google.maps.event.addListenerOnce(this.mapTrack, "idle", () => {
            mapEleTrack.classList.add("show-map");
          });
          // dispensary marker
          // var dispensaryBounds = new google.maps.LatLngBounds();
          //  var disLocation = new google.maps.LatLng(this.trackDataDispensary.latitude, this.trackDataDispensary.longitude);
          //   dispensaryBounds.extend(disLocation);
          //    var dispensary_pin = {
          //     url: 'assets/pin-blue.png', // url
          //     scaledSize: new google.maps.Size(50, 56), // scaled size
          //     origin: new google.maps.Point(0, 0), // origin
          //     anchor: new google.maps.Point(16, 16) // anchor
          //   };
          //   this.driverPin = new google.maps.Marker({
          //     position: disLocation,
          //     map: this.mapTrack,
          //     icon: dispensary_pin,
          //     zoom: 13
          //   });
          var endImage = {
            url: "assets/drop_pin.png", // url
            scaledSize: new google.maps.Size(50, 56), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(16, 16), // anchor
          };
          for (var i = 0; i < this.trackDataOrder.length; i++) {
            // var bounds2 = new google.maps.LatLngBounds();
            // var location = new google.maps.LatLng(this.trackDataOrder[i].dropoff_latitude, this.trackDataOrder[i].dropoff_longitude);
            //      bounds2.extend(location);
            //      this.markerTrack[i] = new google.maps.Marker({
            //        title: ' Order #' + this.trackDataOrder[i].order_id,
            //        position: location,
            //        map: this.mapTrack,
            //        icon: endImage,
            //        zoom: 13
            //      });
            if (this.trackDataOrder[i].order_id === id) {
              var bounds2 = new google.maps.LatLngBounds();
              var location = new google.maps.LatLng(
                this.trackDataOrder[i].dropoff_latitude,
                this.trackDataOrder[i].dropoff_longitude
              );
              bounds2.extend(location);
              this.markerTrack[i] = new google.maps.Marker({
                title: " Order #" + this.trackDataOrder[i].order_id,
                position: location,
                map: this.mapTrack,
                icon: endImage,
                zoom: 13,
              });

              this.infowindowTrack[i] = new google.maps.InfoWindow();
              this.infowindowTrack[i].setContent(this.markerTrack[i].title);
              this.infowindowTrack[i].open(this.mapTrack, this.markerTrack[i]);
              var end = {
                lat: this.trackDataOrder[i].dropoff_latitude,
                lng: this.trackDataOrder[i].dropoff_longitude,
                // lat: 31.470436,
                // lng: 74.410786
              };
              var start = {
                // lat: 31.524241,
                // lng: 74.346054
                lat: this.trackDataDriver.address.latitude,
                lng: this.trackDataDriver.address.longitude,
              };
              this.startDriverLatLng = start;
              console.log("previousDriverLatLng", this.previousDriverLatLng);
              // driver marker initilizer
              var driver_pin_icon = {
                url: "assets/driver-pin.png", // url
                scaledSize: new google.maps.Size(40, 46), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(16, 16), // anchor
              };
              var bounds2 = new google.maps.LatLngBounds();
              bounds2.extend(end);
              this.driverPin = new google.maps.Marker({
                title:
                  this.trackDataDriver.first_name +
                  " " +
                  this.trackDataDriver.last_name +
                  " " +
                  this.trackDataDriver.country_code +
                  " " +
                  this.trackDataDriver.phone_number,
                position: start,
                map: this.mapTrack,
                icon: driver_pin_icon,
                zoom: 13,
              });
              this.driverMarker = new google.maps.InfoWindow();
              this.driverMarker.setContent(this.driverPin.title);
              this.driverMarker.open(this.mapTrack, this.driverPin);
              console.log("start", start);
              console.log("end", end);
              this.calculateRoute(start, end);
              this.intervalSet = setInterval(() => {
                this.fetchDriverFreshData(this.trackDataDriverIdForRoute);
              }, 5000);
            }
          }
          console.log("this.markerTrack", this.markerTrack);
          // $('#trackOrderPop').modal('show');
          $("#trackOrderPop").modal("show", {
            backdrop: "static",
            keyboard: false,
          });
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  calculateRoute(start_location, end_location) {
    console.log("in calculate route start", start_location);
    console.log("in calculate route end", end_location);
    var start = new google.maps.LatLng(start_location.lat, start_location.lng);
    var end = new google.maps.LatLng(end_location.lat, end_location.lng);
    this.chRef.detectChanges();
    var bounds = new google.maps.LatLngBounds();
    bounds.extend(start);
    bounds.extend(end);
    // this.mapTrack.fitBounds(bounds);
    var request = {
      origin: start,
      destination: end,
      travelMode: google.maps.TravelMode.DRIVING,
    };
    var context = this;
    this.directionsService.route(request, function (response, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        context.directionsDisplay.setDirections(response);
        context.directionsDisplay.setMap(context.mapTrack);
      } else {
        alert(
          "Directions Request from " +
            start.toUrlValue(6) +
            " to " +
            end.toUrlValue(6) +
            " failed: " +
            status
        );
      }
    });
  }
  closeTrackOrderPop() {
    clearInterval(this.intervalSet);
  }

  // calculateAndDisplayRoute(directionsDisplay, directionsService,
  //         markerArray, stepDisplay, map) {
  //       // First, remove any existing markers from the map.
  //       for (var i = 0; i < markerArray.length; i++) {
  //         markerArray[i].setMap(null);
  //       }
  //
  //       // Retrieve the start and end locations and create a DirectionsRequest using
  //       // WALKING directions.
  //       directionsService.route({
  //         origin: document.getElementById('start').value,
  //         destination: document.getElementById('end').value,
  //         travelMode: 'WALKING'
  //       }, function(response, status) {
  //         // Route the directions and pass the response to a function to create
  //         // markers for each step.
  //         if (status === 'OK') {
  //           document.getElementById('warnings-panel').innerHTML =
  //               '<b>' + response.routes[0].warnings + '</b>';
  //           directionsDisplay.setDirections(response);
  //           showSteps(response, markerArray, stepDisplay, map);
  //         } else {
  //           window.alert('Directions request failed due to ' + status);
  //         }
  //       });
  //     }

  fetchDriverFreshData(id) {
    this.dataService
      .trackDriver(window.localStorage.getItem("token"), id, this.trackOrderId)
      .subscribe(
        (data) => {
          this.trackDataDriver = data;
          if (
            this.trackDataDriver.order_status === 5 ||
            this.trackDataDriver.order_status === 6 ||
            this.trackDataDriver.order_status === 7
          ) {
            $("#trackOrderPop").modal("hide");
            clearInterval(this.intervalSet);
            this.orderslist(4);
            return;
          }
          for (var i = 0; i < this.trackDataOrder.length; i++) {
            if (this.trackDataOrder[i].is_running === true) {
              var end = {
                lat: this.trackDataOrder[i].dropoff_latitude,
                lng: this.trackDataOrder[i].dropoff_longitude,
                // lat: 31.470436,
                // lng: 74.410786
              };
            }
          }
          this.previousDriverLatLng = this.startDriverLatLng;
          this.startDriverLatLng = {
            // lat: 31.524241,
            // lng: 74.346054
            lat: this.trackDataDriver.address.latitude,
            lng: this.trackDataDriver.address.longitude,
          };
          console.log("start", this.startDriverLatLng);
          console.log("end", end);
          console.log("previousDriverLatLng", this.previousDriverLatLng);
          // this.calculateRoute(this.startDriverLatLng, end);

          this.numberOfDriverLocationChecks =
            this.numberOfDriverLocationChecks + 1;
          this.currentDriverLocation = this.currentDriverLocation + 1;

          this.updateRouteMarkerWithtransition(
            this.driverPin,
            this.previousDriverLatLng,
            this.startDriverLatLng
          );
          this.calculateRoute(this.startDriverLatLng, end);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  async updateRouteMarkerWithtransition(marker, position, result) {
    // console.log('move here', position, result);

    this.r = 0;
    this.deltaLat = (result.lat - position.lat) / this.numDeltas;
    this.deltaLng = (result.lng - position.lng) / this.numDeltas;
    this.moveMarker(marker, position, this.currentDriverLocation);
  }

  moveMarker(marker, position, localDriverLocationNumber) {
    if (localDriverLocationNumber !== this.numberOfDriverLocationChecks) {
      return;
    }

    // console.log('move here 1');
    position.lat += this.deltaLat;
    position.lng += this.deltaLng;
    var latlng = new google.maps.LatLng(position.lat, position.lng);
    // marker.setTitle("Latitude:"+position[0]+" | Longitude:"+position[1]);
    //   console.log('new lat lng',latlng, this.delay);
    marker.setPosition(latlng);
    if (this.r !== this.numDeltas) {
      this.r++;

      setTimeout(() => {
        this.moveMarker(marker, position, this.currentDriverLocation);
      }, this.delay);
    }
  }
  orderDetailCall(id) {
    this.nao.go(30);
    this.orderDetailToReopenOpId = id;
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.orderDetailData = data;
          this.orderDetailData.transaction_missing = false;
          if (this.orderDetailData.payment_type == "Bank Transfer") {
            this.orderDetailData.transaction_missing = true;
          }
          this.customerDetail = this.orderDetailData.customer_detail;
          this.droppOffAddress = this.orderDetailData.dropoff_address;
          // we have to work here
          this.userDropDocs = this.orderDetailData.drop_off_docs;
          console.log("userDropDocs", this.userDropDocs);
          this.orderDataDisplay = this.orderDetailData.order;
          let order_type = this.orderDataDisplay.delivery_man_type;
          if (order_type === 4) {
            this.dineIn = true;
            this.tableNo = this.orderDataDisplay.dine_in_table_number;
          } else {
            this.dineIn = false;
            this.tableNo = "";
          }
          if (order_type === 5) {
            this.pickUp = true;
          } else {
            this.pickUp = false;
          }
          this.pickupAddress = this.orderDetailData.pickup_address;
          this.productData = this.orderDetailData.product;
          this.thirdPartyData = this.orderDetailData.third_party;
          this.onDetailDriverData = this.orderDetailData.driver;
          this.returnOrderItems =
            this.orderDataDisplay.return_items["return_product_list"];
          this.returnOrderItemsLength = this.returnOrderItems.length;
          this.orderCreated = this.orderDetailData.order_created_by;
          this.orderBooked = this.orderDetailData.order_booked_by;
          // console.log('this.orderCreated', this.orderCreated);
          console.log("this.onDetailDriverData", this.onDetailDriverData);
          $("#orderDetailPop").modal("show");

          var cDate = new Date().getDate();
          var cYear = new Date().getFullYear();
          var cMonth = new Date().getUTCMonth() + 1;
          var openTime = this.orderDataDisplay.open_time;
          var tOpen =
            cYear + "/" + cMonth + "/" + cDate + " " + openTime + " " + "UTC";
          var dateObjOpen = new Date(tOpen);
          this.deliverStartDate = dateObjOpen;

          var closeTime = this.orderDataDisplay.close_time;
          var tClose =
            cYear + "/" + cMonth + "/" + cDate + " " + closeTime + " " + "UTC";
          var dateObjClose = new Date(tClose);
          this.deliverEndDate = dateObjClose;
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  packeOrderBookNationWide(id, status) {
    this.thirdPartyOrderId = id;
    this.thirdPartyOrderStatus = status;
    this.thirdPartyName = "";
    this.thirdPartyUrl = "";
    this.thirdPartyId = "";
    this.thirdPartyDate = null;
    $("#packeOrderBookNationWidePop").modal("show");
    this.thirdPartybtn = true;
  }
  checknullValueThirdParty() {
    if (
      this.thirdPartyName !== "" &&
      this.thirdPartyUrl !== "" &&
      this.thirdPartyId !== "" &&
      this.thirdPartyDate !== null
    ) {
      console.log(this.thirdPartyName, this.thirdPartyUrl, this.thirdPartyId);
      this.thirdPartybtn = false;
    } else {
      this.thirdPartybtn = true;
    }
  }
  SetPackeOrderBookNationWide() {
    this.nao.go(30);
    this.thirdPartyDate = this.thirdPartyDate.formatted;
    this.dataService
      .OrderBookNationWide(
        window.localStorage.getItem("token"),
        this.thirdPartyOrderId,
        this.thirdPartyName,
        this.thirdPartyUrl,
        this.thirdPartyId,
        this.thirdPartyDate
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.thirdPartySuccessData = data;
          this.thirdPartySuccessData = this.thirdPartySuccessData.success;
          if (this.thirdPartySuccessData === true) {
            this.orderslist(this.thirdPartyOrderStatus);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  OrderRebook(id, status) {
    this.nao.go(30);
    this.dataService
      .rebookOrder(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.rebookData = data;
          this.rebookData = this.rebookData.success;
          if (this.rebookData === true) {
            toastr.success("Order Rebook Successfuly");
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  OrderReProcess(id, status) {
    this.nao.go(30);
    this.dataService
      .rebookProcess(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.reprocessData = data;
          this.reprocessData = this.reprocessData.success;
          if (this.reprocessData === true) {
            toastr.success("Order Reprocess Successfuly");
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  cancelBatchOrderCall(id, status, index) {
    $(".cancelbatchOrderNewImg" + index).css("display", "none");
    $("#cancelbatchLoader" + index).css("display", "inline-block");
    this.nao.go(30);
    this.dataService
      .cancelBatchOrderStatus(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.cancelStatusSuccess = data;
          $(".cancelbatchOrderNewImg" + index).css("display", "none");
          $("#cancelbatchLoader" + index).css("display", "inline-block");
          this.cancelStatusSuccess = this.cancelStatusSuccess.success;
          if (this.cancelStatusSuccess === true) {
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  cancelOrderCall(id, status, index) {
    $(".cancelOrderNewImg" + index).css("display", "none");
    $("#cancelLoader" + index).css("display", "inline-block");
    $(".cancelLoadercall" + index).css("display", "none");
    $("#cancelLoadercall" + index).css("display", "inline-block");
    $(".cancelOrderCal" + index).css("display", "none");
    $("#cancelOrderCal" + index).css("display", "inline-block");
    this.ordercancelid = this.id;
    console.log("this.ordercancelid", this.ordercancelid);
    this.nao.go(30);
    this.dataService
      .cancelOrderStatus(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.cancelStatusSuccess = data;
          $(".cancelOrderNewImg" + index).css("display", "inline-block");
          $("#cancelLoader" + index).css("display", "none");
          $(".cancelLoadercall" + index).css("display", "inline-block");
          $("#cancelLoadercall" + index).css("display", "none");
          $(".cancelOrderCal" + index).css("display", "none");
          $("#cancelOrderCal" + index).css("display", "inline-block");
          this.cancelStatusSuccess = this.cancelStatusSuccess.success;
          if (this.cancelStatusSuccess === true) {
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  thirdPartyCancelOrderCall(id, status, index) {
    $(".cancelOrderNewImg" + index).css("display", "none");
    $("#cancelLoader" + index).css("display", "inline-block");
    $(".cancelLoadercall" + index).css("display", "none");
    $("#cancelLoadercall" + index).css("display", "inline-block");
    $(".cancelOrderCal" + index).css("display", "none");
    $("#cancelOrderCal" + index).css("display", "inline-block");
    this.ordercancelid = this.id;
    console.log("this.ordercancelid", this.ordercancelid);
    this.nao.go(30);
    this.dataService
      .cancelOrderStatus(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.cancelStatusSuccess = data;
          $(".cancelOrderNewImg" + index).css("display", "inline-block");
          $("#cancelLoader" + index).css("display", "none");
          $(".cancelLoadercall" + index).css("display", "inline-block");
          $("#cancelLoadercall" + index).css("display", "none");
          $(".cancelOrderCal" + index).css("display", "none");
          $("#cancelOrderCal" + index).css("display", "inline-block");
          this.cancelStatusSuccess = this.cancelStatusSuccess.success;
          if (this.cancelStatusSuccess === true) {
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  markAsInTransit(id, status) {
    this.nao.go(30);
    this.dataService
      .orderintransitthirdparty(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.markIntransitData = data;
          this.markIntransitData = this.markIntransitData.success;
          if (this.markIntransitData === true) {
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  returnOrderCall(id, status) {
    this.nao.go(30);
    this.dataService
      .returnOrderStatus(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.returnStatusSuccess = data;
          this.returnStatusSuccess = this.returnStatusSuccess.success;
          if (this.returnStatusSuccess === true) {
            this.orderslist(status);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  returnOrderCallthirdParty() {
    this.orderDeliverDate = this.orderDeliverDate.formatted;
    // console.log(this.orderDeliverPerson, this.orderDeliverHandler,  this.orderDeliverTime, this.orderDeliverDate);
    this.nao.go(30);
    this.dataService
      .returnOrderStatusThairdParty(
        window.localStorage.getItem("token"),
        this.deliverdOrderId,
        this.orderDeliverPerson,
        this.orderDeliverHandler,
        this.orderDeliverTime,
        this.orderDeliverDate
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.markDeliveredData = data;
          if (this.markDeliveredData.success === true) {
            this.orderslist(4);
            this.orderDeliverPerson = "";
            this.orderDeliverHandler = "";
            this.orderDeliverTime = "";
            this.orderDeliverDate = "";
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  orderRollOverCall(id) {
    this.nao.go(30);
    this.dataService
      .orderRollOver(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.rollOverStatusSuccess = data;
          this.rollOverStatusSuccess = this.rollOverStatusSuccess.success;
          if (this.rollOverStatusSuccess === true) {
            this.orderslist(4);
            // this.clearMarker();
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  driverDetails(id) {
    // this.nao.go(30);
    console.log("login data 10");
    this.dataService
      .showDriverDetailWithId(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.findDriverDataDriver = data;
          if (this.findDriverDataDriver.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.findDriverDataDriver.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.findDriverDataDriver.rest_error_code === 3)
            toastr.error("Driver already exists");
          this.dispenseriesDriver = data;
          this.dispenseriesDriver = this.dispenseriesDriver.dispensaries;
          console.log("dispensary length", this.dispenseriesDriver.length);
          this.findDriverDataDriver = data;
          $("#datepicker").val(this.findDriverDataDriver.date_of_birth);
          this.first_nameDriver = this.findDriverDataDriver.first_name;
          this.last_nameDriver = this.findDriverDataDriver.last_name;
          this.emailDriver = this.findDriverDataDriver.email;
          this.phoneDriver =
            this.findDriverDataDriver.country_code +
            "" +
            this.findDriverDataDriver.phone_number;
          this.noteDriver = this.findDriverDataDriver.note;
          $("#pImg1").attr("src", this.findDriverDataDriver.licence_front_url);
          $("#pImg2").attr("src", this.findDriverDataDriver.licence_back_url);
          $("#pImg3").attr("src", this.findDriverDataDriver.reg_book_url);
          this.driving_license_frontDriver =
            this.findDriverDataDriver.licence_front_url;
          this.driving_license_backDriver =
            this.findDriverDataDriver.licence_back_url;
          this.registration_bookDriver = this.findDriverDataDriver.reg_book_url;
          this.userImageDriver = this.findDriverDataDriver.img_url;
          this.findDriverDataDriver = this.findDriverDataDriver.address;
          this.address_line1Driver = this.findDriverDataDriver.address_line1;
          this.address_line2Driver = this.findDriverDataDriver.address_line2;
          this.cityDriver = this.findDriverDataDriver.city;
          this.stateDriver = this.findDriverDataDriver.state;
          this.zipDriver = this.findDriverDataDriver.zip;
          this.areaDriver = this.findDriverDataDriver.area;
          this.longitudeDriver = this.findDriverDataDriver.longitude;
          this.latitudeDriver = this.findDriverDataDriver.latitude;
          this.driverMatchDriver = true;
          // $('#orderDetailPop').modal('hide');
          // setTimeout(() => {
          $("#driverDetailPop").modal("show");
          // }, 1000);
          console.log("cutomer data get with phone#", data);
          // }
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  findcustomerDetail(id) {
    this.nao.go(30);
    this.dataService
      .showCustomerListById(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.findCustomerData = data;
          if (this.findCustomerData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.findCustomerData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.findCustomerData.rest_error_code === 3)
            toastr.error("Customer already exists");
          this.findCustomerData = data;
          this.numberCustomer =
            this.findCustomerData.country_code +
            "" +
            this.findCustomerData.phone_number;
          this.customerDetailDob = this.findCustomerData.date_of_birth;
          console.log(
            "this.number",
            this.numberCustomer,
            this.customerDetailDob
          );
          $("#dobCustomerDetail").val(this.customerDetailDob);
          $("#phoneValue").val(this.numberCustomer);
          this.first_nameCustomer = this.findCustomerData.first_name;
          this.last_nameCustomer = this.findCustomerData.last_name;
          this.accept_marketingCustomer =
            this.findCustomerData.accept_marketing;
          this.is_tax_exemptCustomer = this.findCustomerData.tax_exempt;
          this.emailCustomer = this.findCustomerData.email;
          this.noteCustomer = this.findCustomerData.note;
          this.userImageCustomer = this.findCustomerData.img_url;
          this.findCustomerData = this.findCustomerData.address;
          this.address_line1Customer = this.findCustomerData.address_line1;
          this.address_line2Customer = this.findCustomerData.address_line2;
          this.cityCustomer = this.findCustomerData.city;
          this.stateCustomer = this.findCustomerData.state;
          this.zipCustomer = this.findCustomerData.zip;
          this.areaCustomer = this.findCustomerData.area;
          this.apartCustomer = this.findCustomerData.apart_no;
          this.longitudeCustomer = this.findCustomerData.longitude;
          this.latitudeCustomer = this.findCustomerData.latitude;
          if (this.is_tax_exemptCustomer === true) {
            $("#is_tax_exempt").prop("checked", true);
          }
          if (this.accept_marketingCustomer === true) {
            $("#accept_marketing").prop("checked", true);
          }
          this.customerMatchCustomer = true;
          // console.log('cutomer data get with phone#', data);
          // $('#orderDetailPop').modal('hide');
          // setTimeout(() => {
          $("#customerDetailPop").modal("show");
          // }, 1000);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  modalClos(name) {
    $("#" + name).modal("hide");
    setTimeout(() => {
      $("#" + name).css("overflow-y", "scroll");
      // this.orderDetailCall(this.orderDetailToReopenOpId);
    }, 1000);
  }
  invaliOpen() {
    $("#invalidPayment").modal("show");
  }
  selectDeliveryPerson(order_id) {
    this.delivery_order_id = order_id;
    $(".isNation").prop("checked", false);
    $(".isLocal").prop("checked", false);
    $("input").prop("checked", false);
    this.delivery_man_type = 0;
    this.chRef.detectChanges();
    $("#addDeliveryPersonPop").modal("show");
    this.delivery_sub_btn = true;
  }
  selectDeliveryPersonFromProces(order_id) {
    this.delivery_order_id = order_id;
    $(".isNation1").prop("checked", false);
    $(".isLocal1").prop("checked", false);
    $("input").prop("checked", false);
    this.delivery_man_type = 0;
    this.chRef.detectChanges();
    $("#addDeliveryPersonPopFromProces").modal("show");
    this.delivery_sub_btn = true;
  }
  upadteDeliveryFun(val) {
    if (val === "1") {
      if ($(".isLocal").prop("checked") === true) {
        $(".isNation").prop("checked", false);
        this.delivery_man_type = 1;
        this.delivery_sub_btn = false;
        console.log(val, this.delivery_sub_btn);
      } else {
        this.delivery_sub_btn = true;
      }
    }
    if (val === "3") {
      console.log("3 in");
      if ($(".isNation").prop("checked") === true) {
        $(".isLocal").prop("checked", false);
        this.delivery_man_type = 3;
        this.delivery_sub_btn = false;
        console.log(val, this.delivery_sub_btn);
      } else {
        this.delivery_sub_btn = true;
      }
    }
  }

  upadteDeliveryFun1(val) {
    if (val === "1") {
      if ($(".isLocal1").prop("checked") === true) {
        $(".isNation1").prop("checked", false);
        this.delivery_man_type = 1;
        this.delivery_sub_btn = false;
        console.log(val, this.delivery_sub_btn);
      } else {
        this.delivery_sub_btn = true;
      }
    }
    if (val === "3") {
      console.log("3 in");
      if ($(".isNation1").prop("checked") === true) {
        $(".isLocal1").prop("checked", false);
        this.delivery_man_type = 3;
        this.delivery_sub_btn = false;
        console.log(val, this.delivery_sub_btn);
      } else {
        this.delivery_sub_btn = true;
      }
    }
  }

  setDeliveryManType() {
    this.nao.go(30);
    this.dataService
      .DeliveryManType(
        window.localStorage.getItem("token"),
        this.delivery_man_type,
        this.delivery_order_id
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.DeliveryManTypeData = data;
          if (this.DeliveryManTypeData.success) {
            this.orderslist(this.orderStatus);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  markAsDelivered(orderId, text) {
    this.markAsDeliveredText = text;
    this.deliverdOrderId = orderId;
    this.orderDeliverPerson = "";
    this.orderDeliverHandler = "";
    // this.orderDeliverTime = null;
    this.orderDeliverDate = null;
    this.orderDeliverBtn = true;
    $("#timepicker3").val(null);
    $("#markAsDeliveredPop").modal("show");
  }
  restrictUserInput($event) {
    $event.preventDefault();
  }
  markAsDeliveredVal() {
    this.orderDeliverTime = $("#timepicker3").val();
    if (
      (this.orderDeliverPerson !== "" &&
        this.orderDeliverHandler !== "" &&
        this.orderDeliverTime !== "") ||
      (this.orderDeliverTime !== null && this.orderDeliverDate !== null)
    ) {
      this.orderDeliverBtn = false;
      console.log("orderDeliverBtn", this.orderDeliverBtn);
    } else {
      this.orderDeliverBtn = true;
      console.log("orderDeliverBtn", this.orderDeliverBtn);
    }
  }
  markasDeliveredSubmited() {
    this.orderDeliverDate = this.orderDeliverDate.formatted;
    // console.log(this.orderDeliverPerson, this.orderDeliverHandler,  this.orderDeliverTime, this.orderDeliverDate);
    this.nao.go(30);
    this.dataService
      .markDelivered(
        window.localStorage.getItem("token"),
        this.deliverdOrderId,
        this.orderDeliverPerson,
        this.orderDeliverHandler,
        this.orderDeliverTime,
        this.orderDeliverDate
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.markDeliveredData = data;
          if (this.markDeliveredData.success === true) {
            this.orderslist(4);
            this.orderDeliverPerson = "";
            this.orderDeliverHandler = "";
            this.orderDeliverTime = "";
            this.orderDeliverDate = "";
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  trackUrl(url) {
    window.open(url, "_blank");
    // var url = 'http://w3schools.com';
    // var url2 = url.split('://')[0];
    // var chk_w = url.split('.')[0];
    // console.log('url', url2);
    // console.log('chk_w', chk_w);
    // if (url2 === url) {
    //  window.open('https://' + url, '_blank');
    // }
    // if (url2 === 'http') {
    //   window.open('http://' + url, '_blank');
    // }
    // if (url2 === 'https') {
    //   window.open('https://' + url, '_blank');
    // }
  }
  openDriverInfoPop(id, index) {
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.driverContactInfo = data;
          this.driverContactInfo = this.driverContactInfo.driver;
          $("#returnOrderDriverInfoPop").modal("show");
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  filterOutletId(id, name, outlet, index) {
    this.pageLoad = 0;
    this.outletData1 = outlet;
    this.outletId = id;
    if (this.outletId == -1) {
      this.outletName = "All Outlets";
      this.city_id = "-1";
    }
    if (this.outletId != -1) {
      this.outletName = outlet.name;
      this.city_id;
    }

    this.outletDayindex = -1;
    this.outletDay = "Day - All";
    this.outletDayTime = "Day - All";
    this.selectionDayOpenTime = "-1";
    this.selectionDayCloseTime = "-1";
    this.selectionDayOpenTime2 = "";
    this.selectionDayCloseTime2 = "";
    this.slotsTimingsToShow = [];
    this.slotsTimingsToShowBackup = [];
    this.outletDaySelect = false;

    if (this.outletName == "All") {
      this.outletId = id;
      console.log("outlets all first check", this.outletName, this.outletId);
    }
    if (this.outletName != "All") {
      this.outletId = id;
      console.log("outlets city", this.outletName, this.outletId);
    }
    if (this.outletId != -1) {
      if (this.outletData1.default_delivery_slot === false) {
        this.selectedOutletData = this.outletData1;
        this.timeSlotDetail_delivery_show =
          this.outletData1.delivery_slot_list_json;
      } else {
        this.selectedOutletData = outlet;
        this.timeSlotDetail_delivery_show = outlet.delivery_slot_list_json;
      }
    }
    console.log(
      "timeSlotDetail_delivery_show1",
      this.timeSlotDetail_delivery_show
    );
    for (var i = 0; i < this.timeSlotDetail_delivery_show.length; i++) {
      for (
        var j = 0;
        j < this.timeSlotDetail_delivery_show[i].slot.length;
        j++
      ) {
        var cDate = new Date().getDate();
        var cYear = new Date().getFullYear();
        var cMonth = new Date().getUTCMonth() + 1;
        var openTime = this.timeSlotDetail_delivery_show[i].slot[j].open_time;
        var tOpen =
          cYear + "/" + cMonth + "/" + cDate + " " + openTime + " " + "UTC";
        var dateObjOpen = new Date(tOpen);
        this.timeSlotDetail_delivery_show[i].slot[j].open_time = dateObjOpen;

        var closeTime = this.timeSlotDetail_delivery_show[i].slot[j].close_time;
        var tClose =
          cYear + "/" + cMonth + "/" + cDate + " " + closeTime + " " + "UTC";
        var dateObjClose = new Date(tClose);
        this.timeSlotDetail_delivery_show[i].slot[j].close_time = dateObjClose;
      }
    }
    if (this.outletName.length > 20) {
      this.outletName = name.substring(0, 20);
    }
    this.searchAllOrders();
  }

  filterOutletIdForBatch(id, name) {
    this.outletId = this.dispensary_id;
    // this.outletName = name;
    // if ( name.length > 20  ) {
    //   this.outletName = name.substring(0, 20);
    // }
    // this.getBatcheslist();
    // this.loader = false;

    this.dataService
      .getOutletsByIds(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.outletData1 = data;
          this.outletId = this.outletData1.id;
          this.outletName = this.outletData1.name;
          this.outletDayindex = -1;
          this.outletDay = "Day - All";
          this.outletDayTime = "Day - All";
          this.selectionDayOpenTime = "-1";
          this.selectionDayCloseTime = "-1";
          this.selectionDayOpenTime2 = "";
          this.selectionDayCloseTime2 = "";
          this.slotsTimingsToShow = [];
          this.slotsTimingsToShowBackup = [];
          this.outletDaySelect = false;
          if (this.outletData1.default_delivery_slot === false) {
            this.selectedOutletData = this.outletData1;
            this.timeSlotDetail_delivery_show =
              this.outletData1.delivery_slot_list_json;
          } else {
            this.selectedOutletData = this.outletDatas[0];
            this.timeSlotDetail_delivery_show =
              this.outletDatas[0].delivery_slot_list_json;
          }
          console.log(
            "timeSlotDetail_delivery_show1",
            this.timeSlotDetail_delivery_show
          );

          for (var i = 0; i < this.timeSlotDetail_delivery_show.length; i++) {
            for (
              var j = 0;
              j < this.timeSlotDetail_delivery_show[i].slot.length;
              j++
            ) {
              var cDate = new Date().getDate();
              var cYear = new Date().getFullYear();
              var cMonth = new Date().getUTCMonth() + 1;
              var openTime =
                this.timeSlotDetail_delivery_show[i].slot[j].open_time;
              var tOpen =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                openTime +
                " " +
                "UTC";
              var dateObjOpen = new Date(tOpen);
              this.timeSlotDetail_delivery_show[i].slot[j].open_time =
                dateObjOpen;

              var closeTime =
                this.timeSlotDetail_delivery_show[i].slot[j].close_time;
              var tClose =
                cYear +
                "/" +
                cMonth +
                "/" +
                cDate +
                " " +
                closeTime +
                " " +
                "UTC";
              var dateObjClose = new Date(tClose);
              this.timeSlotDetail_delivery_show[i].slot[j].close_time =
                dateObjClose;
            }
          }
          console.log("problem", this.outletName);
          if (this.outletName.length > 20) {
            this.outletName = name.substring(0, 20);
            console.log("problem", this.outletName);
          }
          this.getBatcheslist();
        },
        (error) => {
          // this.nao.go(100);
        }
      );
  }

  filteraTimeSlotDayBatch(index, day, slots) {
    this.slotsTimingsToShow = [];
    this.outletDayindex = index;
    this.outletDay = day;
    if (day === "Day - All") {
      this.outletDaySelect = false;
    } else {
      this.slotsTimingsToShow = slots;
      this.outletDaySelect = true;
    }
    this.selectionDayOpenTime = "-1";
    this.selectionDayCloseTime = "-1";
    console.log("selectionDayOpenTime", this.selectionDayOpenTime);
    this.getBatcheslist();
  }
  filterTimeSelectionBatch(open_time, close_time) {
    this.selectionDayOpenTime = open_time;
    this.selectionDayCloseTime = close_time;
    this.selectionDayOpenTime2 = open_time;
    this.selectionDayCloseTime2 = close_time;

    this.getBatcheslist();
  }

  outletslist() {
    this.type = "data";
    this.dataService
      .getoutletsList(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.outletDatas = data;
          this.outletData1 = data;
          this.outletDatas = this.outletDatas.items;
          this.outletData1 = this.outletData1.items;
          this.outletDayindex = -1;
          this.selectionDayOpenTime = "-1";
          this.selectionDayCloseTime = "-1";
          this.selectionDayOpenTime2 = "";
          this.selectionDayCloseTime2 = "";
          if (this.outletDatas.length > 0) {
            var outletAllData = this.outletDatas[0];
            this.selectedOutletData = JSON.parse(JSON.stringify(outletAllData));
            this.outletName = this.selectedOutletData.name;
            this.outletId = this.selectedOutletData.id;
            this.timeSlotDetail_delivery_show =
              this.selectedOutletData.delivery_slot_list_json;
            for (var i = 0; i < this.timeSlotDetail_delivery_show.length; i++) {
              for (
                var j = 0;
                j < this.timeSlotDetail_delivery_show[i].slot.length;
                j++
              ) {
                var cDate = new Date().getDate();
                var cYear = new Date().getFullYear();
                var cMonth = new Date().getUTCMonth() + 1;
                var openTime =
                  this.timeSlotDetail_delivery_show[i].slot[j].open_time;
                var tOpen =
                  cYear +
                  "/" +
                  cMonth +
                  "/" +
                  cDate +
                  " " +
                  openTime +
                  " " +
                  "UTC";
                var dateObjOpen = new Date(tOpen);
                this.timeSlotDetail_delivery_show[i].slot[j].open_time =
                  dateObjOpen;

                var closeTime =
                  this.timeSlotDetail_delivery_show[i].slot[j].close_time;
                var tClose =
                  cYear +
                  "/" +
                  cMonth +
                  "/" +
                  cDate +
                  " " +
                  closeTime +
                  " " +
                  "UTC";
                var dateObjClose = new Date(tClose);
                this.timeSlotDetail_delivery_show[i].slot[j].close_time =
                  dateObjClose;
              }
            }
            console.log(
              "outletDataoutletDataoutletDataoutletData on load",
              this.outletDatas
            );

            this.orderslist(0);
          } else {
            this.orderslist(0);
          }
        },
        (error) => {
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  // callEditOrder(order_id){
  // this.events.publish('varientId', id);
  // $('.productHistory').css('display', 'block');
  // $('.productInventry').css('display', 'none');
  // }

  // filteraTimeSlotIdForAll(id, name){
  //   this.id = id;
  //   this.name = name;
  //   this.searchAllOrders();
  // }

  filteraTimeSlotDay(index, day, slots) {
    this.slotsTimingsToShow = [];
    this.outletDayindex = index;
    this.outletDay = day;
    if (day === "Day - All") {
      this.outletDaySelect = false;
    } else {
      this.slotsTimingsToShow = slots;
      this.outletDaySelect = true;
    }
    this.selectionDayOpenTime = "-1";
    this.selectionDayCloseTime = "-1";
    console.log("selectionDayOpenTime", this.selectionDayOpenTime);
    this.searchAllOrders();
  }
  filterTimeSelection(open_time, close_time) {
    this.selectionDayOpenTime = open_time;
    this.selectionDayCloseTime = close_time;
    this.selectionDayOpenTime2 = open_time;
    this.selectionDayCloseTime2 = close_time;

    this.searchAllOrders();
  }

  TimeSlotDays() {
    // this.timeSlotDetail_delivery_show = [];
    // console.log('this.timeSlotDetail_delivery_show.length', this.timeSlotDetail_delivery_show.length);
    // this.dataService.get_outlet_timing(window.localStorage.getItem('token')).subscribe(
    //   (data) => {
    //     this.selectedOutletData = data;
    //     console.log('cities', this.selectedOutletData);
    //     },
    //   (error) => {
    //     // this.nao.go(100);
    //   }
    // );
  }

  // addDayAndTime(day, dayIndex, time, index) {
  //   if (time.is_available === false) {
  //     toastr.error('This slot is not available');
  //     return;
  //   }
  //   // $('.clearSlotSelection').removeClass('selectedSlot');
  //   // setTimeout(() => {
  //   //   $('#timeslot' + index).addClass('selectedSlot');
  //   // }, 500);
  //   this.dayOfGivenTime = day;
  //   this.dayIndex = dayIndex;
  //   console.log('day', this.dayOfGivenTime);
  //   console.log('this.dayIndex', this.dayIndex);
  //   this.time = time;
  //   console.log('day', this.time);
  //
  // }
  messageSubscription: Subscription;
  reloadList: boolean = false;
  ngOnInit() {
    this.TimeSlotDays();
    // this.outletslist();
    // this.outlets();
    this.getServices();
    this.getUnreadMessagesCountForOrders();
    // this.getOrderListing();
    this.getDispensaryListing();
    //this.getOrderServices();
    this.getDispensaryListingforOrder();
    // $('#businessModel').modal('show');
    this.pushReceive = this.pubsub.subscribe("dataChange").subscribe((data) => {
      // if (data === 'order_status') {
      //   this.orderslist();
      // }
    });
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $("#sidebar").css("display", "block");
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#orderListing").css("color", "#d77229");
  }

  unReadMessagesCount: any = [];
  getUnreadMessagesCountForOrders() {
    let param_data = {
      auth_token: localStorage.getItem("token"),
    };
    this.dataService.getUnreadMessagesCount(param_data).subscribe(
      (data: any) => {
        this.nao.go(100);
        if (data.unread_messages_count) {
          this.unReadMessagesCount = data.unread_messages_count;
        } else {
          toastr.error("Something went wrong!");
        }
      },
      (error) => {
        toastr.error("Something went wrong!");
      }
    );
  }

  ngAfterViewInit() {
    this.chRef.detectChanges();

    this.messageSubscription = this.authService.currentMessage.subscribe(
      (value: any) => {
        console.log("valueee", value);
        console.log("statussss:", this.status);

        if (value != null) {
          if (this.checkPopupOpenFlag == true) {
            console.log("statussss in:", this.status);
            this.getUnreadMessagesCountForOrders();
            this.orderslist(this.status);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    );

    //    var context = this;
    //   let mapEle = this.mapElement.nativeElement;
    //      this.map = new google.maps.Map(mapEle, {
    //         zoom: 13,
    //         center: {lat: this.packedDataArray[0].latitude, lng: this.packedDataArray[0].logitude},
    //         mapTypeId: google.maps.MapTypeId.ROADMAP,
    //         disableDefaultUI: true,
    //         zoomControl: true,
    //         scaleControl: true
    //       });
    //      // this.directionsService = new google.maps.DirectionsService();
    //      //  this.directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers: true, polylineOptions: {
    //      //    strokeColor: '#37224e'
    //      //  }});
    //      // this.directionsDisplay.setMap(this.map);
    //        google.maps.event.addListenerOnce(this.map, 'idle', () => {
    //         mapEle.classList.add('show-map');
    //      });
    //        var endImage = {
    //         url: 'assets/drop_pin.png', // url
    //         scaledSize: new google.maps.Size(50, 56), // scaled size
    //         origin: new google.maps.Point(0, 0), // origin
    //         anchor: new google.maps.Point(16, 16) // anchor
    //       };
    //       for (var i = 0; i <= this.packedDataArray.length; i++) {
    //         // if (this.orderData[i].order_status === 2) {
    //           console.log('i', i);
    //        var bounds = new google.maps.LatLngBounds();
    //        var location = new google.maps.LatLng(this.packedDataArray[i].latitude, this.packedDataArray[i].logitude);
    //             bounds.extend(location);
    //             this.marker[i] = new google.maps.Marker({
    //               title: ' Order #' + context.packedDataArray[i].order_no,
    //               position: location,
    //               map: this.map,
    //               icon: endImage,
    //               zoom: 13,
    //             });
    //             this.infowindow[i] = new google.maps.InfoWindow();
    //             // context.infowindow[context.i].setContent(context.marker[context.i].title);
    //             // context.infowindow[context.i].open(context.map, context.marker[context.i]);
    //           (function (i) {
    //           google.maps.event.addListener(context.marker[i], 'click', function() {
    //             console.log('info window chk', i);
    //               context.infowindow[i].setContent(context.marker[i].title);
    //             //  batch Start on marker click
    //             var blue = {
    //                         url: 'assets/pin-blue.png', // url
    //                         scaledSize: new google.maps.Size(50, 56), // scaled size
    //                         origin: new google.maps.Point(0, 0), // origin
    //                         anchor: new google.maps.Point(16, 16) // anchor
    //                       };
    //              var green = {
    //                         url: 'assets/drop_pin.png', // url
    //                         scaledSize: new google.maps.Size(50, 56), // scaled size
    //                         origin: new google.maps.Point(0, 0), // origin
    //                         anchor: new google.maps.Point(16, 16) // anchor
    //                       };
    //                 if ($('#chk' + i).prop('checked') !== true) {
    //                   context.marker[i].setIcon(blue);
    //                   context.map.panTo(context.marker[i].position);
    //                   context.infowindow[i].open(context.map, context.marker[i]);
    //                   $('#chk' + i).prop('checked', true);
    //                   context.batchArray.push({
    //                     order_id: context.packedDataArray[i].order_id
    //                   });
    //                   console.log('order_id: context.orderData[i].order_id', context.packedDataArray[i].order_id, context.batchArray);
    //               } else {
    //                   $('#chk' + i).prop('checked', false);
    //
    //                   context.marker[i].setIcon(green);
    //                   // context.marker[i].setIcon('assets/pin.png');
    //                   context.infowindow[i].close();
    //                 var removeElement = context.batchArray.indexOf(context.packedDataArray[i].order_id);
    //                  context.batchArray.splice(removeElement, 1);
    //                  console.log('this.batchArray false', context.batchArray);
    //               }
    //               if (context.batchArray.length > 0) {
    //                     context.batchBtn = true;
    //                     // this.chRef.detectChanges();
    //                 setTimeout(() => { context.chRef.detectChanges(); }, 100);
    //                     console.log('context.batchArray.length', true);
    //                   } else {
    //                     context.batchBtn = false;
    //                     console.log('context.batchArray.length', false);
    //                     // this.chRef.detectChanges();
    //                 setTimeout(() => { context.chRef.detectChanges(); }, 100);
    //                   }
    //
    //           //  batch end on marker click
    //           });
    //           })(i);
    // }
  }
  getInvoiceId(orderId, status, index) {
    this.order_id = orderId;
    this.order_status = status;
    this.index = index;
    this.invoice_id = "";
    this.applicable = false;
  }
  changeStatusWithInvoiceId() {
    console.log(this.invoice_id);
    this.orderStatusChange(
      this.order_id,
      this.order_status,
      this.index,
      this.invoice_id
    );
  }

  // * Invoice Detail Pop Up START
  setInvoiceImage(event) {
    if (event.target.files && event.target.files[0]) {
      this.invoiceImage = event.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(this.invoiceImage); // Read file as data url
      reader.onloadend = (e) => {
        // function call once readAsDataUrl is completed
        this.invoiceImagePath = e.target["result"] as string; // Set image in element
      };
    }
  }

  sendInvoiceData() {
    if (this.invoice_id || this.invoice_amount || this.invoiceImagePath) {
      if (this.invoice_id && this.invoice_amount && this.invoiceImagePath) {
        var payload = new FormData();
        payload.set("invoice_id", this.invoice_id);
        payload.set("amount", this.invoice_amount);
        payload.set("image", this.invoiceImage, this.invoiceImage.name);
        // TODO Send API call to with invoice data.
        // ? use changeStatusWithInvoiceId() ?
      }
    }
  }
  // * Invoice Detail Pop Up END

  // * Transaction Detail Pop Up START
  getUserAccounts() {
    // TODO API call to get user accounts list
    $("#TransactionDetailPopup").modal("show");
  }

  setTransactionImage(event) {
    if (event.target.files && event.target.files[0]) {
      this.transactionImage = event.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(this.transactionImage); // Read file as data url
      reader.onloadend = (e) => {
        // function call once readAsDataUrl is completed
        this.transactionImagePath = e.target["result"] as string; // Set image in element
      };
    }
  }

  sendTransactionData() {
    var payload = new FormData();
    payload.set("transaction_id", this.transaction_id);
    payload.set("credited_to", this.credited_to);
    payload.set("image", this.transactionImage, this.transactionImage.name);
    // TODO API to send transaction Data.
    // ? make a func same as changeStatusWithInvoiceId() ???
  }
  // * Transaction Detail Pop Up END

  /**
   * This function is not being used as of yet. It was made so that only on process button would be showed in new orders listing.
   * decided not to use it because of unsufficient domain & code understanding
   * @param id order ID
   * @param name OrderStatus
   * @param index index of orderData
   * @param invoice_id Invoice ID
   */
  processOrder(id, name, index, invoice_id) {
    if (this.orderDetailData.transaction_missing) {
      $("#TransactionDetailPopup").modal("show");
    } else {
      var order = this.orderData[index];
      if (
        order.delivery_man_type == 1 ||
        order.delivery_man_type == 3 ||
        order.delivery_man_type == 4 ||
        order.delivery_man_type == 5
      ) {
        this.orderStatusChange(id, name, index, invoice_id);
      } else if (order.delivery_man_type == 0) {
        this.selectDeliveryPersonFromProces(id);
      }
    }
  }

  //get Message listing
  openMessagePopup(data, index) {
    data.unread_messages_count = 0;
    this.checkPopupOpenFlag = false;
    console.log("ttttttt", data);
    const modalRef = this.modalService.open(ChatModalComponent, {
      centered: true,
      windowClass: "in",
      backdropClass: "in",
      backdrop: "static",
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.order = 0;
    this.reloadList = true;
    modalRef.componentInstance.modalClose.subscribe((receivedEntry) => {
      console.log("received entry from popup", receivedEntry);

      if (receivedEntry) {
        this.checkPopupOpenFlag = receivedEntry;
        this.getUnreadMessagesCountForOrders();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/order-listing/order-listing.component.ts